import { Percent, ChainId, WNATIVE, ERC20Token, CurrencyAmount } from '@donaswap/sdk';
import { firechainTokens, riniaTokens, USDC, USDT, WBTC_ETH, BUSD, sepoliaTokens, bscTokens, bscTestnetTokens, polygonTokens, polygonMumbaiTokens, croTokens, croTestnetTokens, avalancheTokens, avalancheFujiTokens, fantomOperaTokens, fantomTestnetTokens, celoTokens, celoAlfajoresTokens, optimismTokens, optimismGoerliTokens, arbitrumTokens, arbitrumGoerliTokens, shibariumTokens, shibariumTestnetTokens, pulsechainTokens, pulsechainTestnetTokens, xenTokens, xenDevnetTokens, harmonyTokens, harmonyTestnetTokens, coinExTokens, coinExTestnetTokens, dogechainTokens, dogechainTestnetTokens, etcTokens, etcTestnetTokens, fusionTokens, fusionTestnetTokens, hecoTokens, hecoTestnetTokens, kccTokens, kccTestnetTokens, klaytnCypressTokens, klaytnBaobabTokens, okxChainTokens, okxChainTestnetTokens, thetaTokens, thetaTestnetTokens, ultronTokens, ultronTestnetTokens, moonbeamTokens, moonriverTokens, moonbaseAlphaTokens, auroraTokens, auroraTestnetTokens, bobaTokens, bobaGoerliTokens, gnosisTokens, gnosisChiadoTokens, metisTokens, metisGoerliTokens, telosTokens, telosTestnetTokens, syscoinTokens, syscoinTanenbaumTokens, iotexTokens, iotexTestnetTokens, shidenTokens, astarTokens, shibunyaTokens, fuseTokens, fuseSparknetTokens, velasTokens, velasTestnetTokens, reiTokens, reiTestnetTokens, kekchainTokens, kekchainTestnetTokens, tomochainTokens, tomochainTestnetTokens, thundercoreTokens, thundercoreTestnetTokens, wanchainTokens, wanchainTestnetTokens, rskTokens, rskTestnetTokens, elastosTokens, elastosTestnetTokens, confluxTokens, confluxTestnetTokens, brisechainTokens, brisechainTestnetTokens, muuchainTokens, muuchainTestnetTokens, cantoTokens, cantoTestnetTokens, oasisEmeraldTokens, oasisTestnetTokens, visionTokens, visionTestnetTokens, stepTokens, stepTestnetTokens, meterTokens, meterTestnetTokens, godwokenTokens, godwokenTestnetTokens, callistoTokens, callistoTestnetTokens, evmosTokens, evmosTestnetTokens, energyWebchainTokens, energyVoltaTokens, baseTokens, baseGoerliTokens, kavaTokens, kavaTestnetTokens, cloverTokens, cloverTestnetTokens, defichainTokens, defichainTestnetTokens, bronosTokens, bronosTestnetTokens, filecoinTokens, filecoinCalibrationTokens, flareTokens, flareTestnetTokens, taraxaTokens, taraxaTestnetTokens, polygonZkEvmTokens, polygonZkEvmTestnetTokens, zksyncTokens, zkSyncTestnetTokens, lineaTestnetTokens, ethereumTokens, goerliTestnetTokens } from '@donaswap/tokens';

var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var BIG_INT_TEN = 10n;
var BIPS_BASE = 10000n;
var MIN_BNB = BIG_INT_TEN ** 16n;
var BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(50n, BIPS_BASE);
var CHAIN_ID_TO_CHAIN_NAME = {
  [ChainId.FIRECHAIN]: "fire",
  [ChainId.RINIA]: "",
  [ChainId.BSC]: "bsc",
  [ChainId.BSC_TESTNET]: "",
  [ChainId.ETHEREUM]: "ethereum",
  [ChainId.GOERLI]: "",
  [ChainId.SEPOLIA]: "",
  [ChainId.POLYGON]: "polygon",
  [ChainId.POLYGON_MUMBAI]: "polygonMumbai",
  [ChainId.CRO]: "cro",
  [ChainId.CRO_TESTNET]: "croTestnet",
  [ChainId.AVALANCHE]: "avalanche",
  [ChainId.AVALANCHE_FUJI]: "avalancheFuji",
  [ChainId.FANTOM_OPERA]: "fantomOpera",
  [ChainId.FANTOM_TESTNET]: "fantomTestnet",
  [ChainId.CELO]: "celo",
  [ChainId.CELO_ALFAJORES]: "celoAlfajores",
  [ChainId.OPTIMISM]: "optimism",
  [ChainId.OPTIMISM_GOERLI]: "optimismGoerlie",
  [ChainId.SHIBARIUM]: "shibarium",
  [ChainId.SHIBARIUM_TESTNET]: "shibariumTestnet",
  [ChainId.PULSECHAIN]: "pulsechain",
  [ChainId.PULSECHAIN_TESTNET]: "pulsechainTestnet",
  [ChainId.XEN]: "xen",
  [ChainId.XEN_DEVNET]: "xenDevnet",
  [ChainId.HARMONY]: "harmony",
  [ChainId.HARMONY_TESTNET]: "harmonyTestnet",
  [ChainId.COINEX]: "coinEx",
  [ChainId.COINEX_TESTNET]: "coinExTestnet",
  [ChainId.DOGECHAIN]: "dogechain",
  [ChainId.DOGECHAIN_TESTNET]: "dogechainTestnet",
  [ChainId.ETHEREUM_CLASSIC]: "EthereumClassic",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "EthereumClassicTestnet",
  [ChainId.FUSION]: "fusion",
  [ChainId.FUSION_TESTNET]: "fusionTestnet",
  [ChainId.HECO]: "heco",
  [ChainId.HECO_TESTNET]: "hecoTestnet",
  [ChainId.KCC]: "kcc",
  [ChainId.KCC_TESTNET]: "kccTestnet",
  [ChainId.KLAYTN]: "klaytn",
  [ChainId.KLAYTN_BAOBAB]: "klaytnBaobob",
  [ChainId.OKXCHAIN]: "okxChain",
  [ChainId.OKXCHAIN_TESTNET]: "okxChainTestnet",
  [ChainId.THETHA]: "theta",
  [ChainId.THETHA_TESTNET]: "thetaTestnet",
  [ChainId.ULTRON]: "ultron",
  [ChainId.ULTRON_TESTNET]: "ultronTestnet",
  [ChainId.MOONBEAM]: "moonbeam",
  [ChainId.MOONRIVER]: "moonriver",
  [ChainId.MOONBASE_ALPHA]: "moonbaseAlpha",
  [ChainId.AURORA]: "aurora",
  [ChainId.AURORA_TESTNET]: "auroraTestnet",
  [ChainId.BOBA]: "boba",
  [ChainId.BOBA_GOERLI]: "bobaGoerli",
  [ChainId.GNOSIS]: "gnosis",
  [ChainId.GNOSIS_CHIADO]: "gnosisChiado",
  [ChainId.METIS]: "metis",
  [ChainId.METIS_GOERLI]: "metisGoerli",
  [ChainId.TELOS]: "telos",
  [ChainId.TELOS_TESTNET]: "telosTestnet",
  [ChainId.SYSCOIN]: "syscoin",
  [ChainId.SYSCOIN_TANENBAUM]: "syscoinTanenbaum",
  [ChainId.IOTEX]: "iotex",
  [ChainId.IOTEX_TESTNET]: "iotexTestnet",
  [ChainId.SHIDEN]: "shiden",
  [ChainId.ASTAR]: "astar",
  [ChainId.SHIBUNYA]: "shibunya",
  [ChainId.FUSE]: "fuse",
  [ChainId.FUSE_SPARKNET]: "fuseSparknet",
  [ChainId.VELAS]: "velas",
  [ChainId.VELAS_TESTNET]: "velasTestnet",
  [ChainId.REI]: "rei",
  [ChainId.REI_TESTNET]: "reiTestnet",
  [ChainId.KEKCHAIN]: "kekchain",
  [ChainId.KEKCHAIN_TESTNET]: "kekchainTestnet",
  [ChainId.TOMOCHAIN]: "tomochain",
  [ChainId.TOMOCHAIN_TESTNET]: "tomochainTestnet",
  [ChainId.THUNDERCORE]: "thundercore",
  [ChainId.THUNDERCORE_TESTNET]: "thundercoreTestnet",
  [ChainId.WANCHAIN]: "wanchain",
  [ChainId.WANCHAIN_TESTNET]: "wanchainTestnet",
  [ChainId.RSK]: "rsk",
  [ChainId.RSK_TESTNET]: "rskTestnet",
  [ChainId.ELASTOS]: "elastos",
  [ChainId.ELASTOS_TESTNET]: "elastosTestnet",
  [ChainId.CONFLUX]: "conflux",
  [ChainId.CONFLUX_TESTNET]: "confluxTestnet",
  [ChainId.BRISECHAIN]: "brisebriseTestnet",
  [ChainId.BRISECHAIN_TESTNET]: "briseTestnet",
  [ChainId.MUUCHAIN]: "muuchain",
  [ChainId.MUUCHAIN_TESTNET]: "muuchainTestnet",
  [ChainId.CANTO]: "canto",
  [ChainId.CANTO_TESTNET]: "cantoTestnet",
  [ChainId.OASIS_EMERALD]: "oasis",
  [ChainId.OASIS_TESTNET]: "oasisTestnet",
  [ChainId.VISION]: "vision",
  [ChainId.VISION_TESTNET]: "visionTestnet",
  [ChainId.STEP]: "step",
  [ChainId.STEP_TESTNET]: "stepTestnet",
  [ChainId.METER]: "meter",
  [ChainId.METER_TESTNET]: "meterTestnet",
  [ChainId.GODWOKEN]: "godwoken",
  [ChainId.GODWOKEN_TESTNET]: "godwokenTestnet",
  [ChainId.CALLISTO]: "callisto",
  [ChainId.CALLISTO_TESTNET]: "callistoTestnet",
  [ChainId.EVMOS]: "evmos",
  [ChainId.EVMOS_TESTNET]: "evmosTestnet",
  [ChainId.ENERGY_WEB_CHAIN]: "energywebchain",
  [ChainId.ENERGY_VOLTA]: "energyVolta",
  [ChainId.BASE]: "base",
  [ChainId.BASE_GOERLI]: "baseGoerli",
  [ChainId.KAVA]: "kava",
  [ChainId.KAVA_TESTNET]: "kavaTestnet",
  [ChainId.CLOVER]: "clover",
  [ChainId.CLOVER_TESTNET]: "cloverTestnet",
  [ChainId.DEFICHAIN]: "defichain",
  [ChainId.DEFICHAIN_TESTNET]: "defichainTestnet",
  [ChainId.BRONOS]: "bronos",
  [ChainId.BRONOS_TESTNET]: "bronosTestnet",
  [ChainId.FILECOIN]: "filecoin",
  [ChainId.FILECOIN_CALIBRATION]: "filecoinCalibration",
  [ChainId.FLARE]: "flare",
  [ChainId.FLARE_TESTNET]: "flareTestnet",
  [ChainId.TARAXA]: "taraxa",
  [ChainId.TARAXA_TESTNET]: "taraxaTestnet",
  [ChainId.ARBITRUM_ONE]: "arbitrum",
  [ChainId.ARBITRUM_GOERLI]: "",
  [ChainId.POLYGON_ZKEVM]: "polygon_zkevm",
  [ChainId.POLYGON_ZKEVM_TESTNET]: "",
  [ChainId.ZKSYNC]: "era",
  [ChainId.ZKSYNC_TESTNET]: "",
  [ChainId.LINEA_TESTNET]: ""
};
var SMART_ROUTER_ADDRESSES = {
  [ChainId.FIRECHAIN]: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
  [ChainId.RINIA]: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
  [ChainId.ETHEREUM]: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
  [ChainId.GOERLI]: "0x9a489505a00cE272eAa5e07Dba6491314CaE3796",
  [ChainId.SEPOLIA]: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
  [ChainId.BSC]: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
  [ChainId.BSC_TESTNET]: "0x9a489505a00cE272eAa5e07Dba6491314CaE3796",
  [ChainId.POLYGON]: "0x9a489505a00cE272eAa5e07Dba6491314CaE3796",
  [ChainId.POLYGON_MUMBAI]: "0x9a489505a00cE272eAa5e07Dba6491314CaE3796",
  [ChainId.CRO]: "0x9a489505a00cE272eAa5e07Dba6491314CaE3796",
  [ChainId.CRO_TESTNET]: "0x9a489505a00cE272eAa5e07Dba6491314CaE3796",
  [ChainId.AVALANCHE]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.AVALANCHE_FUJI]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FANTOM_OPERA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FANTOM_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CELO]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CELO_ALFAJORES]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OPTIMISM]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OPTIMISM_GOERLI]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ARBITRUM_ONE]: "0x32226588378236Fd0c7c4053999F88aC0e5cAc77",
  [ChainId.ARBITRUM_GOERLI]: "0xBee35e9Cbd9595355Eaf5DE2055EF525adB41bE6",
  [ChainId.SHIBARIUM]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.SHIBARIUM_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.PULSECHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.PULSECHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.XEN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.XEN_DEVNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.HARMONY]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.HARMONY_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.COINEX]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.COINEX_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.DOGECHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.DOGECHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ETHEREUM_CLASSIC]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FUSION]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FUSION_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.HECO]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.HECO_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KCC]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KCC_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KLAYTN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KLAYTN_BAOBAB]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OKXCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OKXCHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.THETHA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.THETHA_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ULTRON]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ULTRON_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.MOONBEAM]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.MOONRIVER]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.MOONBASE_ALPHA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.AURORA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.AURORA_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BOBA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BOBA_GOERLI]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.GNOSIS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.GNOSIS_CHIADO]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.METIS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.METIS_GOERLI]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TELOS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TELOS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.SYSCOIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.SYSCOIN_TANENBAUM]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.IOTEX]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.IOTEX_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.SHIDEN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ASTAR]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.SHIBUNYA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FUSE]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FUSE_SPARKNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.VELAS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.VELAS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.REI]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.REI_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KEKCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KEKCHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TOMOCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TOMOCHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.THUNDERCORE]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.THUNDERCORE_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.WANCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.WANCHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.RSK]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.RSK_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ELASTOS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ELASTOS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CONFLUX]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CONFLUX_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BRISECHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BRISECHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.MUUCHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.MUUCHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CANTO]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CANTO_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OASIS_EMERALD]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.OASIS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.VISION]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.VISION_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.STEP]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.STEP_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.METER]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.METER_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.GODWOKEN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.GODWOKEN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CALLISTO]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CALLISTO_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.EVMOS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.EVMOS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ENERGY_WEB_CHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ENERGY_VOLTA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BASE]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BASE_GOERLI]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KAVA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.KAVA_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CLOVER]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.CLOVER_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.DEFICHAIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.DEFICHAIN_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BRONOS]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.BRONOS_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FILECOIN]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FILECOIN_CALIBRATION]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FLARE]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.FLARE_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TARAXA]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.TARAXA_TESTNET]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  // TODO: new chains
  [ChainId.POLYGON_ZKEVM]: "0x678Aa4bF4E210cf2166753e054d5b7c31cc7fa86",
  [ChainId.POLYGON_ZKEVM_TESTNET]: "0x365C5F0B816828936320ea143e337fbA7D1b911E",
  [ChainId.ZKSYNC]: "0x6162e4bD45239416d2Ef198F5D03A968182A30E4",
  [ChainId.ZKSYNC_TESTNET]: "0x2CecA0100bB12F3Ee164D260b058281809C7e1E8",
  [ChainId.LINEA_TESTNET]: "0x21d809FB4052bb1807cfe2418bA638d72F4aEf87"
};
var V2_ROUTER_ADDRESS = {
  [ChainId.FIRECHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.RINIA]: "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  [ChainId.ETHEREUM]: "0x3BC722f252C7bAE2f55647e49aDcB9d33Ff6eBcC",
  [ChainId.GOERLI]: "0x3BC722f252C7bAE2f55647e49aDcB9d33Ff6eBcC",
  [ChainId.SEPOLIA]: "0x3BC722f252C7bAE2f55647e49aDcB9d33Ff6eBcC",
  [ChainId.BSC]: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
  [ChainId.BSC_TESTNET]: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
  [ChainId.POLYGON]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.POLYGON_MUMBAI]: "0x181647f38E49De48a5939f506545F0085378A0BB",
  [ChainId.CRO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CRO_TESTNET]: "0x0FCb226Ce65dd93fE2D5279649f1E8841F731489",
  [ChainId.AVALANCHE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.AVALANCHE_FUJI]: "0x730253eee681A77435a68C7f0C3f23AbEd458858",
  [ChainId.FANTOM_OPERA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FANTOM_TESTNET]: "0x730253eee681A77435a68C7f0C3f23AbEd458858",
  [ChainId.CELO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CELO_ALFAJORES]: "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  [ChainId.OPTIMISM]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OPTIMISM_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SHIBARIUM]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SHIBARIUM_TESTNET]: "0xb44DFD33a02DD87a5A16544F39391deC8DC235a0",
  [ChainId.PULSECHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.PULSECHAIN_TESTNET]: "0xD81ad778fb32EA7Bc4C660e3236100c70762CCfB",
  [ChainId.XEN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.XEN_DEVNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.HARMONY]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.HARMONY_TESTNET]: "0x8147852f0e66f5DB5EeeF0A068d7F191a3e11c9c",
  [ChainId.COINEX]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.COINEX_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.DOGECHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.DOGECHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ETHEREUM_CLASSIC]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FUSION]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FUSION_TESTNET]: "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  [ChainId.HECO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.HECO_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KCC]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KCC_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KLAYTN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KLAYTN_BAOBAB]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OKXCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OKXCHAIN_TESTNET]: "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  [ChainId.THETHA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.THETHA_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ULTRON]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ULTRON_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MOONBEAM]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MOONRIVER]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MOONBASE_ALPHA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.AURORA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.AURORA_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BOBA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BOBA_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.GNOSIS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.GNOSIS_CHIADO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.METIS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.METIS_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.TELOS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.TELOS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SYSCOIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SYSCOIN_TANENBAUM]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.IOTEX]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.IOTEX_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SHIDEN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ASTAR]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SHIBUNYA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FUSE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FUSE_SPARKNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.VELAS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.VELAS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.REI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.REI_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KEKCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KEKCHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.TOMOCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.TOMOCHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.THUNDERCORE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.THUNDERCORE_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.WANCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.WANCHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.RSK]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.RSK_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ELASTOS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ELASTOS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CONFLUX]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CONFLUX_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BRISECHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BRISECHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MUUCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MUUCHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CANTO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CANTO_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OASIS_EMERALD]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OASIS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.VISION]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.VISION_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.STEP]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.STEP_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.METER]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.METER_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.GODWOKEN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.GODWOKEN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CALLISTO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CALLISTO_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.EVMOS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.EVMOS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ENERGY_WEB_CHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ENERGY_VOLTA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BASE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BASE_GOERLI]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.KAVA]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.KAVA_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.CLOVER]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.CLOVER_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.DEFICHAIN]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.DEFICHAIN_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.BRONOS]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.BRONOS_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.FILECOIN]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.FILECOIN_CALIBRATION]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.FLARE]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.FLARE_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.TARAXA]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.TARAXA_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.ZKSYNC]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.ZKSYNC_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.ARBITRUM_ONE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ARBITRUM_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.POLYGON_ZKEVM]: "0x8cFe327CEc66d1C090Dd72bd0FF11d690C33a2Eb",
  [ChainId.POLYGON_ZKEVM_TESTNET]: "0x1ac9F6489487a282961b3929bCFA0a773251315E",
  [ChainId.LINEA_TESTNET]: "0xD7A304138D50C125733d1fE8a2041199E4944Aa1"
};
var STABLE_SWAP_INFO_ADDRESS = {
  [ChainId.FIRECHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.RINIA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ETHEREUM]: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
  [ChainId.GOERLI]: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
  [ChainId.SEPOLIA]: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
  [ChainId.BSC]: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
  [ChainId.BSC_TESTNET]: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
  [ChainId.POLYGON]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.POLYGON_MUMBAI]: "0x181647f38E49De48a5939f506545F0085378A0BB",
  [ChainId.CRO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CRO_TESTNET]: "0x0FCb226Ce65dd93fE2D5279649f1E8841F731489",
  [ChainId.AVALANCHE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.AVALANCHE_FUJI]: "0x730253eee681A77435a68C7f0C3f23AbEd458858",
  [ChainId.FANTOM_OPERA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FANTOM_TESTNET]: "0x730253eee681A77435a68C7f0C3f23AbEd458858",
  [ChainId.CELO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CELO_ALFAJORES]: "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  [ChainId.OPTIMISM]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OPTIMISM_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ARBITRUM_ONE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ARBITRUM_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SHIBARIUM]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SHIBARIUM_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.PULSECHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.PULSECHAIN_TESTNET]: "0xD81ad778fb32EA7Bc4C660e3236100c70762CCfB",
  [ChainId.XEN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.XEN_DEVNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.HARMONY]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.HARMONY_TESTNET]: "0x8147852f0e66f5DB5EeeF0A068d7F191a3e11c9c",
  [ChainId.COINEX]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.COINEX_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.DOGECHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.DOGECHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ETHEREUM_CLASSIC]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FUSION]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FUSION_TESTNET]: "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  [ChainId.HECO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.HECO_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KCC]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KCC_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KLAYTN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KLAYTN_BAOBAB]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OKXCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OKXCHAIN_TESTNET]: "0xC751d479E574647f0F20B1A3A6f5D220b6Fd7De3",
  [ChainId.THETHA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.THETHA_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ULTRON]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ULTRON_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MOONBEAM]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MOONRIVER]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MOONBASE_ALPHA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.AURORA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.AURORA_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BOBA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BOBA_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.GNOSIS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.GNOSIS_CHIADO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.METIS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.METIS_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.TELOS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.TELOS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SYSCOIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SYSCOIN_TANENBAUM]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.IOTEX]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.IOTEX_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SHIDEN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ASTAR]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.SHIBUNYA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FUSE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.FUSE_SPARKNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.VELAS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.VELAS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.REI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.REI_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KEKCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KEKCHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.TOMOCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.TOMOCHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.THUNDERCORE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.THUNDERCORE_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.WANCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.WANCHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.RSK]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.RSK_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ELASTOS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ELASTOS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CONFLUX]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CONFLUX_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BRISECHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BRISECHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MUUCHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.MUUCHAIN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CANTO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CANTO_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OASIS_EMERALD]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.OASIS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.VISION]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.VISION_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.STEP]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.STEP_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.METER]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.METER_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.GODWOKEN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.GODWOKEN_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CALLISTO]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.CALLISTO_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.EVMOS]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.EVMOS_TESTNET]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ENERGY_WEB_CHAIN]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.ENERGY_VOLTA]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BASE]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.BASE_GOERLI]: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
  [ChainId.KAVA]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.KAVA_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.CLOVER]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.CLOVER_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.DEFICHAIN]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.DEFICHAIN_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.BRONOS]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.BRONOS_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.FILECOIN]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.FILECOIN_CALIBRATION]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.FLARE]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.FLARE_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.TARAXA]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.TARAXA_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.POLYGON_ZKEVM]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.POLYGON_ZKEVM_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.ZKSYNC]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.ZKSYNC_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff",
  [ChainId.LINEA_TESTNET]: "0x6539020f987F7010C7E1d1CCaDc58DCF3523c5ff"
};
var BASES_TO_CHECK_TRADES_AGAINST = {
  [ChainId.FIRECHAIN]: [firechainTokens.wfire],
  [ChainId.RINIA]: [riniaTokens.wfire],
  [ChainId.ETHEREUM]: [WNATIVE[ChainId.ETHEREUM], USDC[ChainId.ETHEREUM], USDT[ChainId.ETHEREUM], WBTC_ETH],
  [ChainId.GOERLI]: [WNATIVE[ChainId.GOERLI], USDC[ChainId.GOERLI], BUSD[ChainId.GOERLI]],
  [ChainId.SEPOLIA]: [sepoliaTokens.weth, sepoliaTokens.dona],
  [ChainId.BSC]: [
    bscTokens.wbnb,
    bscTokens.flame,
    bscTokens.busd,
    bscTokens.usdt,
    bscTokens.btcb,
    bscTokens.eth,
    bscTokens.usdc
  ],
  [ChainId.BSC_TESTNET]: [bscTestnetTokens.wbnb, bscTestnetTokens.flame, bscTestnetTokens.busd],
  [ChainId.POLYGON]: [polygonTokens.wmatic],
  [ChainId.POLYGON_MUMBAI]: [polygonMumbaiTokens.wmatic],
  [ChainId.CRO]: [croTokens.wcro],
  [ChainId.CRO_TESTNET]: [croTestnetTokens.wcro],
  [ChainId.AVALANCHE]: [avalancheTokens.wavax],
  [ChainId.AVALANCHE_FUJI]: [avalancheFujiTokens.wavax],
  [ChainId.FANTOM_OPERA]: [fantomOperaTokens.wftm],
  [ChainId.FANTOM_TESTNET]: [fantomTestnetTokens.wftm],
  [ChainId.CELO]: [celoTokens.wcelo],
  [ChainId.CELO_ALFAJORES]: [celoAlfajoresTokens.wcelo],
  [ChainId.OPTIMISM]: [optimismTokens.weth],
  [ChainId.OPTIMISM_GOERLI]: [optimismGoerliTokens.weth],
  [ChainId.ARBITRUM_ONE]: [arbitrumTokens.weth, arbitrumTokens.usdt, arbitrumTokens.usdc],
  [ChainId.ARBITRUM_GOERLI]: [arbitrumGoerliTokens.weth, arbitrumGoerliTokens.usdc],
  [ChainId.SHIBARIUM]: [shibariumTokens.wbone],
  [ChainId.SHIBARIUM_TESTNET]: [shibariumTestnetTokens.wbone],
  [ChainId.PULSECHAIN]: [pulsechainTokens.wpls],
  [ChainId.PULSECHAIN_TESTNET]: [pulsechainTestnetTokens.wpls],
  [ChainId.XEN]: [xenTokens.wxn],
  [ChainId.XEN_DEVNET]: [xenDevnetTokens.wxn],
  [ChainId.HARMONY]: [harmonyTokens.wone],
  [ChainId.HARMONY_TESTNET]: [harmonyTestnetTokens.wone],
  [ChainId.COINEX]: [coinExTokens.wcet],
  [ChainId.COINEX_TESTNET]: [coinExTestnetTokens.wcet],
  [ChainId.DOGECHAIN]: [dogechainTokens.wdoge],
  [ChainId.DOGECHAIN_TESTNET]: [dogechainTestnetTokens.wdoge],
  [ChainId.ETHEREUM_CLASSIC]: [etcTokens.wetc],
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: [etcTestnetTokens.wetc],
  [ChainId.FUSION]: [fusionTokens.wfsn],
  [ChainId.FUSION_TESTNET]: [fusionTestnetTokens.wfsn],
  [ChainId.HECO]: [hecoTokens.wht],
  [ChainId.HECO_TESTNET]: [hecoTestnetTokens.wht],
  [ChainId.KCC]: [kccTokens.wkcs],
  [ChainId.KCC_TESTNET]: [kccTestnetTokens.wkcs],
  [ChainId.KLAYTN]: [klaytnCypressTokens.wklay],
  [ChainId.KLAYTN_BAOBAB]: [klaytnBaobabTokens.wklay],
  [ChainId.OKXCHAIN]: [okxChainTokens.wokt],
  [ChainId.OKXCHAIN_TESTNET]: [okxChainTestnetTokens.wokt],
  [ChainId.THETHA]: [thetaTokens.wtfuel],
  [ChainId.THETHA_TESTNET]: [thetaTestnetTokens.wtfuel],
  [ChainId.ULTRON]: [ultronTokens.wulx],
  [ChainId.ULTRON_TESTNET]: [ultronTestnetTokens.wulx],
  [ChainId.MOONBEAM]: [moonbeamTokens.wglmr],
  [ChainId.MOONRIVER]: [moonriverTokens.wmovr],
  [ChainId.MOONBASE_ALPHA]: [moonbaseAlphaTokens.wdev],
  [ChainId.AURORA]: [auroraTokens.weth],
  [ChainId.AURORA_TESTNET]: [auroraTestnetTokens.weth],
  [ChainId.BOBA]: [bobaTokens.weth],
  [ChainId.BOBA_GOERLI]: [bobaGoerliTokens.weth],
  [ChainId.GNOSIS]: [gnosisTokens.wxdai],
  [ChainId.GNOSIS_CHIADO]: [gnosisChiadoTokens.wxdai],
  [ChainId.METIS]: [metisTokens.wmetis],
  [ChainId.METIS_GOERLI]: [metisGoerliTokens.wmetis],
  [ChainId.TELOS]: [telosTokens.wtlos],
  [ChainId.TELOS_TESTNET]: [telosTestnetTokens.wtlos],
  [ChainId.SYSCOIN]: [syscoinTokens.wsys],
  [ChainId.SYSCOIN_TANENBAUM]: [syscoinTanenbaumTokens.wsys],
  [ChainId.IOTEX]: [iotexTokens.wiotx],
  [ChainId.IOTEX_TESTNET]: [iotexTestnetTokens.wiotx],
  [ChainId.SHIDEN]: [shidenTokens.wsdn],
  [ChainId.ASTAR]: [astarTokens.wastr],
  [ChainId.SHIBUNYA]: [shibunyaTokens.wsby],
  [ChainId.FUSE]: [fuseTokens.wfuse],
  [ChainId.FUSE_SPARKNET]: [fuseSparknetTokens.wfuse],
  [ChainId.VELAS]: [velasTokens.wvlx],
  [ChainId.VELAS_TESTNET]: [velasTestnetTokens.wvlx],
  [ChainId.REI]: [reiTokens.wrei],
  [ChainId.REI_TESTNET]: [reiTestnetTokens.wrei],
  [ChainId.KEKCHAIN]: [kekchainTokens.wkek],
  [ChainId.KEKCHAIN_TESTNET]: [kekchainTestnetTokens.wkek],
  [ChainId.TOMOCHAIN]: [tomochainTokens.wtomo],
  [ChainId.TOMOCHAIN_TESTNET]: [tomochainTestnetTokens.wtomo],
  [ChainId.THUNDERCORE]: [thundercoreTokens.wtt],
  [ChainId.THUNDERCORE_TESTNET]: [thundercoreTestnetTokens.wtt],
  [ChainId.WANCHAIN]: [wanchainTokens.wwan],
  [ChainId.WANCHAIN_TESTNET]: [wanchainTestnetTokens.wwan],
  [ChainId.RSK]: [rskTokens.wrbtc],
  [ChainId.RSK_TESTNET]: [rskTestnetTokens.wrbtc],
  [ChainId.ELASTOS]: [elastosTokens.wela],
  [ChainId.ELASTOS_TESTNET]: [elastosTestnetTokens.wela],
  [ChainId.CONFLUX]: [confluxTokens.wcfx],
  [ChainId.CONFLUX_TESTNET]: [confluxTestnetTokens.wcfx],
  [ChainId.BRISECHAIN]: [brisechainTokens.wbrise],
  [ChainId.BRISECHAIN_TESTNET]: [brisechainTestnetTokens.wbrise],
  [ChainId.MUUCHAIN]: [muuchainTokens.wmuu],
  [ChainId.MUUCHAIN_TESTNET]: [muuchainTestnetTokens.wmuu],
  [ChainId.CANTO]: [cantoTokens.wcanto],
  [ChainId.CANTO_TESTNET]: [cantoTestnetTokens.wcanto],
  [ChainId.OASIS_EMERALD]: [oasisEmeraldTokens.wrose],
  [ChainId.OASIS_TESTNET]: [oasisTestnetTokens.wrose],
  [ChainId.VISION]: [visionTokens.wvs],
  [ChainId.VISION_TESTNET]: [visionTestnetTokens.wvs],
  [ChainId.STEP]: [stepTokens.wfitfi],
  [ChainId.STEP_TESTNET]: [stepTestnetTokens.wfitfi],
  [ChainId.METER]: [meterTokens.wmtr],
  [ChainId.METER_TESTNET]: [meterTestnetTokens.wmtr],
  [ChainId.GODWOKEN]: [godwokenTokens.wpckb],
  [ChainId.GODWOKEN_TESTNET]: [godwokenTestnetTokens.wpckb],
  [ChainId.CALLISTO]: [callistoTokens.wclo],
  [ChainId.CALLISTO_TESTNET]: [callistoTestnetTokens.wclo],
  [ChainId.EVMOS]: [evmosTokens.wevmos],
  [ChainId.EVMOS_TESTNET]: [evmosTestnetTokens.wevmos],
  [ChainId.ENERGY_WEB_CHAIN]: [energyWebchainTokens.wewt],
  [ChainId.ENERGY_VOLTA]: [energyVoltaTokens.wewt],
  [ChainId.BASE]: [baseTokens.weth],
  [ChainId.BASE_GOERLI]: [baseGoerliTokens.weth],
  [ChainId.KAVA]: [kavaTokens.wkava],
  [ChainId.KAVA_TESTNET]: [kavaTestnetTokens.wkava],
  [ChainId.CLOVER]: [cloverTokens.wclv],
  [ChainId.CLOVER_TESTNET]: [cloverTestnetTokens.wclv],
  [ChainId.DEFICHAIN]: [defichainTokens.wdfi],
  [ChainId.DEFICHAIN_TESTNET]: [defichainTestnetTokens.wdfi],
  [ChainId.BRONOS]: [bronosTokens.wbro],
  [ChainId.BRONOS_TESTNET]: [bronosTestnetTokens.wbro],
  [ChainId.FILECOIN]: [filecoinTokens.wfil],
  [ChainId.FILECOIN_CALIBRATION]: [filecoinCalibrationTokens.wfil],
  [ChainId.FLARE]: [flareTokens.wflr],
  [ChainId.FLARE_TESTNET]: [flareTestnetTokens.wflr],
  [ChainId.TARAXA]: [taraxaTokens.wtara],
  [ChainId.TARAXA_TESTNET]: [taraxaTestnetTokens.wtara],
  [ChainId.POLYGON_ZKEVM]: [polygonZkEvmTokens.weth, polygonZkEvmTokens.usdt],
  [ChainId.POLYGON_ZKEVM_TESTNET]: [polygonZkEvmTestnetTokens.weth, polygonZkEvmTestnetTokens.usdt],
  [ChainId.ZKSYNC]: [zksyncTokens.usdc, zksyncTokens.weth],
  [ChainId.ZKSYNC_TESTNET]: [zkSyncTestnetTokens.usdc, zkSyncTestnetTokens.weth],
  [ChainId.LINEA_TESTNET]: [lineaTestnetTokens.usdc, lineaTestnetTokens.weth]
};
var ADDITIONAL_BASES = {
  [ChainId.BSC]: {
    // SNFTS-SFUND
    [bscTokens.snfts.address]: [bscTokens.sfund],
    [bscTokens.ankr.address]: [bscTokens.ankrbnb],
    [bscTokens.ankrbnb.address]: [bscTokens.ankrETH, bscTokens.ankr],
    [bscTokens.ankrETH.address]: [bscTokens.ankrbnb],
    // REVV - EDU
    [bscTokens.revv.address]: [bscTokens.edu],
    [bscTokens.edu.address]: [bscTokens.revv],
    // unshETH - USH
    [bscTokens.unshETH.address]: [bscTokens.ush],
    [bscTokens.ush.address]: [bscTokens.unshETH]
  },
  [ChainId.ETHEREUM]: {
    // alETH - ALCX
    [ethereumTokens.alcx.address]: [ethereumTokens.alETH],
    [ethereumTokens.alETH.address]: [ethereumTokens.alcx],
    // rETH - ETH
    [ethereumTokens.weth.address]: [ethereumTokens.rETH]
  }
};
var CUSTOM_BASES = {
  [ChainId.BSC]: {
    [bscTokens.axlusdc.address]: [bscTokens.usdt]
  }
};
var V2_FEE_PATH_PLACEHOLDER = 8388608;
var MSG_SENDER = "0x0000000000000000000000000000000000000001";
var ADDRESS_THIS = "0x0000000000000000000000000000000000000002";
var MIXED_ROUTE_QUOTER_ADDRESSES = {
  [ChainId.FIRECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RINIA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM]: "0x678Aa4bF4E210cf2166753e054d5b7c31cc7fa86",
  [ChainId.GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SEPOLIA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BSC]: "0x678Aa4bF4E210cf2166753e054d5b7c31cc7fa86",
  [ChainId.BSC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.POLYGON]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.POLYGON_MUMBAI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CRO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CRO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.AVALANCHE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.AVALANCHE_FUJI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FANTOM_OPERA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FANTOM_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CELO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CELO_ALFAJORES]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OPTIMISM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OPTIMISM_GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIBARIUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIBARIUM_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.PULSECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.PULSECHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.XEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.XEN_DEVNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HARMONY]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HARMONY_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.COINEX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.COINEX_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DOGECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DOGECHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM_CLASSIC]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSION_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HECO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HECO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KCC]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KCC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KLAYTN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KLAYTN_BAOBAB]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OKXCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OKXCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THETHA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THETHA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ULTRON]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ULTRON_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MOONBEAM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MOONRIVER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MOONBASE_ALPHA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.AURORA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.AURORA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BOBA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BOBA_GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GNOSIS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GNOSIS_CHIADO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METIS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METIS_GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TELOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TELOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SYSCOIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SYSCOIN_TANENBAUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.IOTEX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.IOTEX_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIDEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ASTAR]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIBUNYA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSE_SPARKNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VELAS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VELAS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.REI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.REI_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KEKCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KEKCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TOMOCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TOMOCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THUNDERCORE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THUNDERCORE_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.WANCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.WANCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RSK]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RSK_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ELASTOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ELASTOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CONFLUX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CONFLUX_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRISECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRISECHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MUUCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MUUCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CANTO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CANTO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OASIS_EMERALD]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OASIS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VISION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VISION_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.STEP]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.STEP_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METER_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GODWOKEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GODWOKEN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CALLISTO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CALLISTO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.EVMOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.EVMOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ENERGY_WEB_CHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ENERGY_VOLTA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BASE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BASE_GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KAVA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KAVA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CLOVER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CLOVER_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DEFICHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DEFICHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRONOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRONOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FILECOIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FILECOIN_CALIBRATION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FLARE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FLARE_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TARAXA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TARAXA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  // TODO: new chains
  [ChainId.ARBITRUM_ONE]: "0x3652Fc6EDcbD76161b8554388867d3dAb65eCA93",
  [ChainId.ARBITRUM_GOERLI]: "0x805e03325116Da555Babf012C7bd490Bdd6EEa95",
  [ChainId.POLYGON_ZKEVM]: "0x4c650FB471fe4e0f476fD3437C3411B1122c4e3B",
  [ChainId.POLYGON_ZKEVM_TESTNET]: "0x9CFCdecF9e37Bf25023A2B42537127c1089600fE",
  [ChainId.ZKSYNC]: "0x",
  [ChainId.ZKSYNC_TESTNET]: "0x5d2D9b1B04735DFECF48E6be1A7F391e7071DDc9",
  [ChainId.LINEA_TESTNET]: "0x7d3ed219e45637Cfa77b1a634d0489a2950d1B7F"
};
var V3_QUOTER_ADDRESSES = {
  [ChainId.FIRECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RINIA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GOERLI]: "0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2",
  [ChainId.SEPOLIA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BSC]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BSC_TESTNET]: "0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2",
  [ChainId.POLYGON]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.POLYGON_MUMBAI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CRO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CRO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.AVALANCHE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.AVALANCHE_FUJI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FANTOM_OPERA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FANTOM_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CELO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CELO_ALFAJORES]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OPTIMISM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OPTIMISM_GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIBARIUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIBARIUM_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.PULSECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.PULSECHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.XEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.XEN_DEVNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HARMONY]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HARMONY_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.COINEX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.COINEX_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DOGECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DOGECHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM_CLASSIC]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSION_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HECO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.HECO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KCC]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KCC_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KLAYTN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KLAYTN_BAOBAB]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OKXCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OKXCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THETHA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THETHA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ULTRON]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ULTRON_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MOONBEAM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MOONRIVER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MOONBASE_ALPHA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.AURORA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.AURORA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BOBA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BOBA_GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GNOSIS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GNOSIS_CHIADO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METIS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METIS_GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TELOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TELOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SYSCOIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SYSCOIN_TANENBAUM]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.IOTEX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.IOTEX_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIDEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ASTAR]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.SHIBUNYA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FUSE_SPARKNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VELAS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VELAS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.REI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.REI_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KEKCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KEKCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TOMOCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TOMOCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THUNDERCORE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.THUNDERCORE_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.WANCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.WANCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RSK]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.RSK_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ELASTOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ELASTOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CONFLUX]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CONFLUX_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRISECHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRISECHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MUUCHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.MUUCHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CANTO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CANTO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OASIS_EMERALD]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.OASIS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VISION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.VISION_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.STEP]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.STEP_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.METER_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GODWOKEN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.GODWOKEN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CALLISTO]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CALLISTO_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.EVMOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.EVMOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ENERGY_WEB_CHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ENERGY_VOLTA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BASE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BASE_GOERLI]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KAVA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.KAVA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CLOVER]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.CLOVER_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DEFICHAIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.DEFICHAIN_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRONOS]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.BRONOS_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FILECOIN]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FILECOIN_CALIBRATION]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FLARE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.FLARE_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TARAXA]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.TARAXA_TESTNET]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  // TODO: new chains
  [ChainId.ARBITRUM_ONE]: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997",
  [ChainId.ARBITRUM_GOERLI]: "0xC0F9488345ed89105b3bd135150905F718Bb254E",
  [ChainId.POLYGON_ZKEVM]: "0x864ED564875BdDD6F421e226494a0E7c071C06f8",
  [ChainId.POLYGON_ZKEVM_TESTNET]: "0xA9c08a89Be4503E04Fd84Eadad4320eE34e9B11D",
  [ChainId.ZKSYNC]: "0x",
  [ChainId.ZKSYNC_TESTNET]: "0x42929984eBFC7C3AF4e7dA2e33C9dEe593eB0e4F",
  [ChainId.LINEA_TESTNET]: "0x669254936caE83bE34008BdFdeeA63C902497B31"
};

// evm/constants/gasModel/v2.ts
var BASE_SWAP_COST_V2 = 135000n;
var COST_PER_EXTRA_HOP_V2 = 50000n;
var COST_PER_UNINIT_TICK = 0n;
var BASE_SWAP_COST_V3 = (id) => {
  switch (id) {
    case ChainId.FIRECHAIN:
    case ChainId.RINIA:
    case ChainId.ETHEREUM:
    case ChainId.GOERLI:
    case ChainId.SEPOLIA:
    case ChainId.BSC:
    case ChainId.BSC_TESTNET:
    case ChainId.POLYGON:
    case ChainId.POLYGON_MUMBAI:
    case ChainId.POLYGON_ZKEVM:
    case ChainId.POLYGON_ZKEVM_TESTNET:
    case ChainId.CRO:
    case ChainId.CRO_TESTNET:
    case ChainId.AVALANCHE:
    case ChainId.AVALANCHE_FUJI:
    case ChainId.FANTOM_OPERA:
    case ChainId.FANTOM_TESTNET:
    case ChainId.CELO:
    case ChainId.CELO_ALFAJORES:
    case ChainId.OPTIMISM:
    case ChainId.OPTIMISM_GOERLI:
    case ChainId.ARBITRUM_ONE:
    case ChainId.ARBITRUM_GOERLI:
    case ChainId.SHIBARIUM:
    case ChainId.SHIBARIUM_TESTNET:
    case ChainId.PULSECHAIN:
    case ChainId.PULSECHAIN_TESTNET:
    case ChainId.XEN:
    case ChainId.XEN_DEVNET:
    case ChainId.HARMONY:
    case ChainId.HARMONY_TESTNET:
    case ChainId.COINEX:
    case ChainId.COINEX_TESTNET:
    case ChainId.DOGECHAIN:
    case ChainId.DOGECHAIN_TESTNET:
    case ChainId.ETHEREUM_CLASSIC:
    case ChainId.ETHEREUM_CLASSIC_TESTNET:
    case ChainId.FUSION:
    case ChainId.FUSION_TESTNET:
    case ChainId.HECO:
    case ChainId.HECO_TESTNET:
    case ChainId.KCC:
    case ChainId.KCC_TESTNET:
    case ChainId.KLAYTN:
    case ChainId.KLAYTN_BAOBAB:
    case ChainId.OKXCHAIN:
    case ChainId.OKXCHAIN_TESTNET:
    case ChainId.THETHA:
    case ChainId.THETHA_TESTNET:
    case ChainId.ULTRON:
    case ChainId.ULTRON_TESTNET:
    case ChainId.MOONBEAM:
    case ChainId.MOONRIVER:
    case ChainId.MOONBASE_ALPHA:
    case ChainId.AURORA:
    case ChainId.AURORA_TESTNET:
    case ChainId.BOBA:
    case ChainId.BOBA_GOERLI:
    case ChainId.GNOSIS:
    case ChainId.GNOSIS_CHIADO:
    case ChainId.METIS:
    case ChainId.METIS_GOERLI:
    case ChainId.TELOS:
    case ChainId.TELOS_TESTNET:
    case ChainId.SYSCOIN:
    case ChainId.SYSCOIN_TANENBAUM:
    case ChainId.IOTEX:
    case ChainId.IOTEX_TESTNET:
    case ChainId.SHIDEN:
    case ChainId.ASTAR:
    case ChainId.SHIBUNYA:
    case ChainId.FUSE:
    case ChainId.FUSE_SPARKNET:
    case ChainId.VELAS:
    case ChainId.VELAS_TESTNET:
    case ChainId.REI:
    case ChainId.REI_TESTNET:
    case ChainId.KEKCHAIN:
    case ChainId.KEKCHAIN_TESTNET:
    case ChainId.TOMOCHAIN:
    case ChainId.TOMOCHAIN_TESTNET:
    case ChainId.THUNDERCORE:
    case ChainId.THUNDERCORE_TESTNET:
    case ChainId.WANCHAIN:
    case ChainId.WANCHAIN_TESTNET:
    case ChainId.RSK:
    case ChainId.RSK_TESTNET:
    case ChainId.ELASTOS:
    case ChainId.ELASTOS_TESTNET:
    case ChainId.CONFLUX:
    case ChainId.CONFLUX_TESTNET:
    case ChainId.BRISECHAIN:
    case ChainId.BRISECHAIN_TESTNET:
    case ChainId.MUUCHAIN:
    case ChainId.MUUCHAIN_TESTNET:
    case ChainId.CANTO:
    case ChainId.CANTO_TESTNET:
    case ChainId.OASIS_EMERALD:
    case ChainId.OASIS_TESTNET:
    case ChainId.VISION:
    case ChainId.VISION_TESTNET:
    case ChainId.STEP:
    case ChainId.STEP_TESTNET:
    case ChainId.METER:
    case ChainId.METER_TESTNET:
    case ChainId.GODWOKEN:
    case ChainId.GODWOKEN_TESTNET:
    case ChainId.CALLISTO:
    case ChainId.CALLISTO_TESTNET:
    case ChainId.EVMOS:
    case ChainId.EVMOS_TESTNET:
    case ChainId.ENERGY_WEB_CHAIN:
    case ChainId.ENERGY_VOLTA:
    case ChainId.BASE:
    case ChainId.BASE_GOERLI:
    case ChainId.KAVA:
    case ChainId.KAVA_TESTNET:
    case ChainId.CLOVER_TESTNET:
    case ChainId.DEFICHAIN:
    case ChainId.DEFICHAIN_TESTNET:
    case ChainId.BRONOS:
    case ChainId.BRONOS_TESTNET:
    case ChainId.FILECOIN:
    case ChainId.FILECOIN_CALIBRATION:
    case ChainId.FLARE:
    case ChainId.FLARE_TESTNET:
    case ChainId.TARAXA:
    case ChainId.TARAXA_TESTNET:
    case ChainId.ZKSYNC:
    case ChainId.ZKSYNC_TESTNET:
    case ChainId.LINEA_TESTNET:
      return 2000n;
    default:
      return 0n;
  }
};
var COST_PER_INIT_TICK = (id) => {
  switch (id) {
    case ChainId.FIRECHAIN:
    case ChainId.RINIA:
    case ChainId.ETHEREUM:
    case ChainId.GOERLI:
    case ChainId.SEPOLIA:
    case ChainId.BSC:
    case ChainId.BSC_TESTNET:
    case ChainId.POLYGON:
    case ChainId.POLYGON_MUMBAI:
    case ChainId.POLYGON_ZKEVM:
    case ChainId.POLYGON_ZKEVM_TESTNET:
    case ChainId.CRO:
    case ChainId.CRO_TESTNET:
    case ChainId.AVALANCHE:
    case ChainId.AVALANCHE_FUJI:
    case ChainId.FANTOM_OPERA:
    case ChainId.FANTOM_TESTNET:
    case ChainId.CELO:
    case ChainId.CELO_ALFAJORES:
    case ChainId.OPTIMISM:
    case ChainId.OPTIMISM_GOERLI:
    case ChainId.ARBITRUM_ONE:
    case ChainId.ARBITRUM_GOERLI:
    case ChainId.SHIBARIUM:
    case ChainId.SHIBARIUM_TESTNET:
    case ChainId.PULSECHAIN:
    case ChainId.PULSECHAIN_TESTNET:
    case ChainId.XEN:
    case ChainId.XEN_DEVNET:
    case ChainId.HARMONY:
    case ChainId.HARMONY_TESTNET:
    case ChainId.COINEX:
    case ChainId.COINEX_TESTNET:
    case ChainId.DOGECHAIN:
    case ChainId.DOGECHAIN_TESTNET:
    case ChainId.ETHEREUM_CLASSIC:
    case ChainId.ETHEREUM_CLASSIC_TESTNET:
    case ChainId.FUSION:
    case ChainId.FUSION_TESTNET:
    case ChainId.HECO:
    case ChainId.HECO_TESTNET:
    case ChainId.KCC:
    case ChainId.KCC_TESTNET:
    case ChainId.KLAYTN:
    case ChainId.KLAYTN_BAOBAB:
    case ChainId.OKXCHAIN:
    case ChainId.OKXCHAIN_TESTNET:
    case ChainId.THETHA:
    case ChainId.THETHA_TESTNET:
    case ChainId.ULTRON:
    case ChainId.ULTRON_TESTNET:
    case ChainId.MOONBEAM:
    case ChainId.MOONRIVER:
    case ChainId.MOONBASE_ALPHA:
    case ChainId.AURORA:
    case ChainId.AURORA_TESTNET:
    case ChainId.BOBA:
    case ChainId.BOBA_GOERLI:
    case ChainId.GNOSIS:
    case ChainId.GNOSIS_CHIADO:
    case ChainId.METIS:
    case ChainId.METIS_GOERLI:
    case ChainId.TELOS:
    case ChainId.TELOS_TESTNET:
    case ChainId.SYSCOIN:
    case ChainId.SYSCOIN_TANENBAUM:
    case ChainId.IOTEX:
    case ChainId.IOTEX_TESTNET:
    case ChainId.SHIDEN:
    case ChainId.ASTAR:
    case ChainId.SHIBUNYA:
    case ChainId.FUSE:
    case ChainId.FUSE_SPARKNET:
    case ChainId.VELAS:
    case ChainId.VELAS_TESTNET:
    case ChainId.REI:
    case ChainId.REI_TESTNET:
    case ChainId.KEKCHAIN:
    case ChainId.KEKCHAIN_TESTNET:
    case ChainId.TOMOCHAIN:
    case ChainId.TOMOCHAIN_TESTNET:
    case ChainId.THUNDERCORE:
    case ChainId.THUNDERCORE_TESTNET:
    case ChainId.WANCHAIN:
    case ChainId.WANCHAIN_TESTNET:
    case ChainId.RSK:
    case ChainId.RSK_TESTNET:
    case ChainId.ELASTOS:
    case ChainId.ELASTOS_TESTNET:
    case ChainId.CONFLUX:
    case ChainId.CONFLUX_TESTNET:
    case ChainId.BRISECHAIN:
    case ChainId.BRISECHAIN_TESTNET:
    case ChainId.MUUCHAIN:
    case ChainId.MUUCHAIN_TESTNET:
    case ChainId.CANTO:
    case ChainId.CANTO_TESTNET:
    case ChainId.OASIS_EMERALD:
    case ChainId.OASIS_TESTNET:
    case ChainId.VISION:
    case ChainId.VISION_TESTNET:
    case ChainId.STEP:
    case ChainId.STEP_TESTNET:
    case ChainId.METER:
    case ChainId.METER_TESTNET:
    case ChainId.GODWOKEN:
    case ChainId.GODWOKEN_TESTNET:
    case ChainId.CALLISTO:
    case ChainId.CALLISTO_TESTNET:
    case ChainId.EVMOS:
    case ChainId.EVMOS_TESTNET:
    case ChainId.ENERGY_WEB_CHAIN:
    case ChainId.ENERGY_VOLTA:
    case ChainId.BASE:
    case ChainId.BASE_GOERLI:
    case ChainId.KAVA:
    case ChainId.KAVA_TESTNET:
    case ChainId.CLOVER_TESTNET:
    case ChainId.DEFICHAIN:
    case ChainId.DEFICHAIN_TESTNET:
    case ChainId.BRONOS:
    case ChainId.BRONOS_TESTNET:
    case ChainId.FILECOIN:
    case ChainId.FILECOIN_CALIBRATION:
    case ChainId.FLARE:
    case ChainId.FLARE_TESTNET:
    case ChainId.TARAXA:
    case ChainId.TARAXA_TESTNET:
    case ChainId.ZKSYNC:
    case ChainId.ZKSYNC_TESTNET:
    case ChainId.LINEA_TESTNET:
      return 31000n;
    default:
      return 0n;
  }
};
var COST_PER_HOP_V3 = (id) => {
  switch (id) {
    case ChainId.FIRECHAIN:
    case ChainId.RINIA:
    case ChainId.ETHEREUM:
    case ChainId.GOERLI:
    case ChainId.SEPOLIA:
    case ChainId.BSC:
    case ChainId.BSC_TESTNET:
    case ChainId.POLYGON:
    case ChainId.POLYGON_MUMBAI:
    case ChainId.POLYGON_ZKEVM:
    case ChainId.POLYGON_ZKEVM_TESTNET:
    case ChainId.CRO:
    case ChainId.CRO_TESTNET:
    case ChainId.AVALANCHE:
    case ChainId.AVALANCHE_FUJI:
    case ChainId.FANTOM_OPERA:
    case ChainId.FANTOM_TESTNET:
    case ChainId.CELO:
    case ChainId.CELO_ALFAJORES:
    case ChainId.OPTIMISM:
    case ChainId.OPTIMISM_GOERLI:
    case ChainId.ARBITRUM_ONE:
    case ChainId.ARBITRUM_GOERLI:
    case ChainId.SHIBARIUM:
    case ChainId.SHIBARIUM_TESTNET:
    case ChainId.PULSECHAIN:
    case ChainId.PULSECHAIN_TESTNET:
    case ChainId.XEN:
    case ChainId.XEN_DEVNET:
    case ChainId.HARMONY:
    case ChainId.HARMONY_TESTNET:
    case ChainId.COINEX:
    case ChainId.COINEX_TESTNET:
    case ChainId.DOGECHAIN:
    case ChainId.DOGECHAIN_TESTNET:
    case ChainId.ETHEREUM_CLASSIC:
    case ChainId.ETHEREUM_CLASSIC_TESTNET:
    case ChainId.FUSION:
    case ChainId.FUSION_TESTNET:
    case ChainId.HECO:
    case ChainId.HECO_TESTNET:
    case ChainId.KCC:
    case ChainId.KCC_TESTNET:
    case ChainId.KLAYTN:
    case ChainId.KLAYTN_BAOBAB:
    case ChainId.OKXCHAIN:
    case ChainId.OKXCHAIN_TESTNET:
    case ChainId.THETHA:
    case ChainId.THETHA_TESTNET:
    case ChainId.ULTRON:
    case ChainId.ULTRON_TESTNET:
    case ChainId.MOONBEAM:
    case ChainId.MOONRIVER:
    case ChainId.MOONBASE_ALPHA:
    case ChainId.AURORA:
    case ChainId.AURORA_TESTNET:
    case ChainId.BOBA:
    case ChainId.BOBA_GOERLI:
    case ChainId.GNOSIS:
    case ChainId.GNOSIS_CHIADO:
    case ChainId.METIS:
    case ChainId.METIS_GOERLI:
    case ChainId.TELOS:
    case ChainId.TELOS_TESTNET:
    case ChainId.SYSCOIN:
    case ChainId.SYSCOIN_TANENBAUM:
    case ChainId.IOTEX:
    case ChainId.IOTEX_TESTNET:
    case ChainId.SHIDEN:
    case ChainId.ASTAR:
    case ChainId.SHIBUNYA:
    case ChainId.FUSE:
    case ChainId.FUSE_SPARKNET:
    case ChainId.VELAS:
    case ChainId.VELAS_TESTNET:
    case ChainId.REI:
    case ChainId.REI_TESTNET:
    case ChainId.KEKCHAIN:
    case ChainId.KEKCHAIN_TESTNET:
    case ChainId.TOMOCHAIN:
    case ChainId.TOMOCHAIN_TESTNET:
    case ChainId.THUNDERCORE:
    case ChainId.THUNDERCORE_TESTNET:
    case ChainId.WANCHAIN:
    case ChainId.WANCHAIN_TESTNET:
    case ChainId.RSK:
    case ChainId.RSK_TESTNET:
    case ChainId.ELASTOS:
    case ChainId.ELASTOS_TESTNET:
    case ChainId.CONFLUX:
    case ChainId.CONFLUX_TESTNET:
    case ChainId.BRISECHAIN:
    case ChainId.BRISECHAIN_TESTNET:
    case ChainId.MUUCHAIN:
    case ChainId.MUUCHAIN_TESTNET:
    case ChainId.CANTO:
    case ChainId.CANTO_TESTNET:
    case ChainId.OASIS_EMERALD:
    case ChainId.OASIS_TESTNET:
    case ChainId.VISION:
    case ChainId.VISION_TESTNET:
    case ChainId.STEP:
    case ChainId.STEP_TESTNET:
    case ChainId.METER:
    case ChainId.METER_TESTNET:
    case ChainId.GODWOKEN:
    case ChainId.GODWOKEN_TESTNET:
    case ChainId.CALLISTO:
    case ChainId.CALLISTO_TESTNET:
    case ChainId.EVMOS:
    case ChainId.EVMOS_TESTNET:
    case ChainId.ENERGY_WEB_CHAIN:
    case ChainId.ENERGY_VOLTA:
    case ChainId.BASE:
    case ChainId.BASE_GOERLI:
    case ChainId.KAVA:
    case ChainId.KAVA_TESTNET:
    case ChainId.CLOVER_TESTNET:
    case ChainId.DEFICHAIN:
    case ChainId.DEFICHAIN_TESTNET:
    case ChainId.BRONOS:
    case ChainId.BRONOS_TESTNET:
    case ChainId.FILECOIN:
    case ChainId.FILECOIN_CALIBRATION:
    case ChainId.FLARE:
    case ChainId.FLARE_TESTNET:
    case ChainId.TARAXA:
    case ChainId.TARAXA_TESTNET:
    case ChainId.ZKSYNC:
    case ChainId.ZKSYNC_TESTNET:
    case ChainId.LINEA_TESTNET:
      return 80000n;
    default:
      return 0n;
  }
};

// evm/constants/gasModel/stableSwap.ts
var BASE_SWAP_COST_STABLE_SWAP = 180000n;
var COST_PER_EXTRA_HOP_STABLE_SWAP = 70000n;
var usdGasTokensByChain = {
  [ChainId.FIRECHAIN]: [firechainTokens.usdt],
  [ChainId.RINIA]: [riniaTokens.usdt],
  [ChainId.ETHEREUM]: [ethereumTokens.usdt],
  [ChainId.GOERLI]: [goerliTestnetTokens.usdc],
  [ChainId.SEPOLIA]: [sepoliaTokens.usdt],
  [ChainId.BSC]: [bscTokens.busd],
  [ChainId.BSC_TESTNET]: [bscTestnetTokens.busd],
  [ChainId.POLYGON]: [polygonTokens.usdt],
  [ChainId.POLYGON_MUMBAI]: [polygonMumbaiTokens.usdt],
  [ChainId.CRO]: [croTokens.usdt],
  [ChainId.CRO_TESTNET]: [croTestnetTokens.usdt],
  [ChainId.AVALANCHE]: [avalancheTokens.usdt],
  [ChainId.AVALANCHE_FUJI]: [avalancheFujiTokens.usdt],
  [ChainId.FANTOM_OPERA]: [fantomOperaTokens.usdt],
  [ChainId.FANTOM_TESTNET]: [fantomTestnetTokens.usdt],
  [ChainId.CELO]: [celoTokens.usdt],
  [ChainId.CELO_ALFAJORES]: [celoAlfajoresTokens.usdt],
  [ChainId.OPTIMISM]: [optimismTokens.usdt],
  [ChainId.OPTIMISM_GOERLI]: [optimismGoerliTokens.usdt],
  [ChainId.ARBITRUM_ONE]: [arbitrumTokens.usdc],
  [ChainId.ARBITRUM_GOERLI]: [arbitrumGoerliTokens.usdc],
  [ChainId.SHIBARIUM]: [shibariumTokens.usdt],
  [ChainId.SHIBARIUM_TESTNET]: [shibariumTestnetTokens.usdt],
  [ChainId.PULSECHAIN]: [pulsechainTokens.usdt],
  [ChainId.PULSECHAIN_TESTNET]: [pulsechainTestnetTokens.usdt],
  [ChainId.XEN]: [xenTokens.usdt],
  [ChainId.XEN_DEVNET]: [xenDevnetTokens.usdt],
  [ChainId.HARMONY]: [harmonyTokens.usdt],
  [ChainId.HARMONY_TESTNET]: [harmonyTestnetTokens.usdt],
  [ChainId.COINEX]: [coinExTokens.usdt],
  [ChainId.COINEX_TESTNET]: [coinExTestnetTokens.usdt],
  [ChainId.DOGECHAIN]: [dogechainTokens.usdt],
  [ChainId.DOGECHAIN_TESTNET]: [dogechainTestnetTokens.usdt],
  [ChainId.ETHEREUM_CLASSIC]: [etcTokens.usdt],
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: [etcTestnetTokens.usdt],
  [ChainId.FUSION]: [fusionTokens.usdt],
  [ChainId.FUSION_TESTNET]: [fusionTestnetTokens.usdt],
  [ChainId.HECO]: [hecoTokens.usdt],
  [ChainId.HECO_TESTNET]: [hecoTestnetTokens.usdt],
  [ChainId.KCC]: [kccTokens.usdt],
  [ChainId.KCC_TESTNET]: [kccTestnetTokens.usdt],
  [ChainId.KLAYTN]: [klaytnCypressTokens.usdt],
  [ChainId.KLAYTN_BAOBAB]: [klaytnBaobabTokens.usdt],
  [ChainId.OKXCHAIN]: [okxChainTokens.usdt],
  [ChainId.OKXCHAIN_TESTNET]: [okxChainTestnetTokens.usdt],
  [ChainId.THETHA]: [thetaTokens.usdt],
  [ChainId.THETHA_TESTNET]: [thetaTestnetTokens.usdt],
  [ChainId.ULTRON]: [ultronTokens.usdt],
  [ChainId.ULTRON_TESTNET]: [ultronTestnetTokens.usdt],
  [ChainId.MOONBEAM]: [moonbeamTokens.usdt],
  [ChainId.MOONRIVER]: [moonriverTokens.usdt],
  [ChainId.MOONBASE_ALPHA]: [moonbaseAlphaTokens.usdt],
  [ChainId.AURORA]: [auroraTokens.usdt],
  [ChainId.AURORA_TESTNET]: [auroraTestnetTokens.usdt],
  [ChainId.BOBA]: [bobaTokens.usdt],
  [ChainId.BOBA_GOERLI]: [bobaGoerliTokens.usdt],
  [ChainId.GNOSIS]: [gnosisTokens.usdt],
  [ChainId.GNOSIS_CHIADO]: [gnosisChiadoTokens.usdt],
  [ChainId.METIS]: [metisTokens.usdt],
  [ChainId.METIS_GOERLI]: [metisGoerliTokens.usdt],
  [ChainId.TELOS]: [telosTokens.usdt],
  [ChainId.TELOS_TESTNET]: [telosTestnetTokens.usdt],
  [ChainId.SYSCOIN]: [syscoinTokens.usdt],
  [ChainId.SYSCOIN_TANENBAUM]: [syscoinTanenbaumTokens.usdt],
  [ChainId.IOTEX]: [iotexTokens.usdt],
  [ChainId.IOTEX_TESTNET]: [iotexTestnetTokens.usdt],
  [ChainId.SHIDEN]: [shidenTokens.usdt],
  [ChainId.ASTAR]: [astarTokens.usdt],
  [ChainId.SHIBUNYA]: [shibunyaTokens.usdt],
  [ChainId.FUSE]: [fuseTokens.usdt],
  [ChainId.FUSE_SPARKNET]: [fuseSparknetTokens.usdt],
  [ChainId.VELAS]: [velasTokens.usdt],
  [ChainId.VELAS_TESTNET]: [velasTestnetTokens.usdt],
  [ChainId.REI]: [reiTokens.usdt],
  [ChainId.REI_TESTNET]: [reiTestnetTokens.usdt],
  [ChainId.KEKCHAIN]: [kekchainTokens.usdt],
  [ChainId.KEKCHAIN_TESTNET]: [kekchainTestnetTokens.usdt],
  [ChainId.TOMOCHAIN]: [tomochainTokens.usdt],
  [ChainId.TOMOCHAIN_TESTNET]: [tomochainTestnetTokens.usdt],
  [ChainId.THUNDERCORE]: [thundercoreTokens.usdt],
  [ChainId.THUNDERCORE_TESTNET]: [thundercoreTestnetTokens.usdt],
  [ChainId.WANCHAIN]: [wanchainTokens.usdt],
  [ChainId.WANCHAIN_TESTNET]: [wanchainTestnetTokens.usdt],
  [ChainId.RSK]: [rskTokens.usdt],
  [ChainId.RSK_TESTNET]: [rskTestnetTokens.usdt],
  [ChainId.ELASTOS]: [elastosTokens.usdt],
  [ChainId.ELASTOS_TESTNET]: [elastosTestnetTokens.usdt],
  [ChainId.CONFLUX]: [confluxTokens.usdt],
  [ChainId.CONFLUX_TESTNET]: [confluxTestnetTokens.usdt],
  [ChainId.BRISECHAIN]: [brisechainTokens.usdt],
  [ChainId.BRISECHAIN_TESTNET]: [brisechainTestnetTokens.usdt],
  [ChainId.MUUCHAIN]: [muuchainTokens.usdt],
  [ChainId.MUUCHAIN_TESTNET]: [muuchainTestnetTokens.usdt],
  [ChainId.CANTO]: [cantoTokens.usdt],
  [ChainId.CANTO_TESTNET]: [cantoTestnetTokens.usdt],
  [ChainId.OASIS_EMERALD]: [oasisEmeraldTokens.usdt],
  [ChainId.OASIS_TESTNET]: [oasisTestnetTokens.usdt],
  [ChainId.VISION]: [visionTokens.usdt],
  [ChainId.VISION_TESTNET]: [visionTestnetTokens.usdt],
  [ChainId.STEP]: [stepTokens.usdt],
  [ChainId.STEP_TESTNET]: [stepTestnetTokens.usdt],
  [ChainId.METER]: [meterTokens.usdt],
  [ChainId.METER_TESTNET]: [meterTestnetTokens.usdt],
  [ChainId.GODWOKEN]: [godwokenTokens.usdt],
  [ChainId.GODWOKEN_TESTNET]: [godwokenTestnetTokens.usdt],
  [ChainId.CALLISTO]: [callistoTokens.usdt],
  [ChainId.CALLISTO_TESTNET]: [callistoTestnetTokens.usdt],
  [ChainId.EVMOS]: [evmosTokens.usdt],
  [ChainId.EVMOS_TESTNET]: [evmosTestnetTokens.usdt],
  [ChainId.ENERGY_WEB_CHAIN]: [energyWebchainTokens.usdt],
  [ChainId.ENERGY_VOLTA]: [energyVoltaTokens.usdt],
  [ChainId.BASE]: [baseTokens.usdt],
  [ChainId.BASE_GOERLI]: [baseGoerliTokens.usdt],
  [ChainId.KAVA]: [kavaTokens.usdt],
  [ChainId.KAVA_TESTNET]: [kavaTestnetTokens.usdt],
  [ChainId.CLOVER]: [cloverTokens.usdt],
  [ChainId.CLOVER_TESTNET]: [cloverTestnetTokens.usdt],
  [ChainId.DEFICHAIN]: [defichainTokens.usdt],
  [ChainId.DEFICHAIN_TESTNET]: [defichainTestnetTokens.usdt],
  [ChainId.BRONOS]: [bronosTokens.usdt],
  [ChainId.BRONOS_TESTNET]: [bronosTestnetTokens.usdt],
  [ChainId.FILECOIN]: [filecoinTokens.usdt],
  [ChainId.FILECOIN_CALIBRATION]: [filecoinCalibrationTokens.usdt],
  [ChainId.FLARE]: [flareTokens.usdt],
  [ChainId.FLARE_TESTNET]: [flareTestnetTokens.usdt],
  [ChainId.TARAXA]: [taraxaTokens.usdt],
  [ChainId.TARAXA_TESTNET]: [taraxaTestnetTokens.usdt],
  // TODO: new chains
  [ChainId.POLYGON_ZKEVM]: [polygonZkEvmTokens.usdt],
  [ChainId.POLYGON_ZKEVM_TESTNET]: [polygonZkEvmTestnetTokens.usdt],
  [ChainId.ZKSYNC]: [zksyncTokens.usdc],
  [ChainId.ZKSYNC_TESTNET]: [zkSyncTestnetTokens.usdc],
  [ChainId.LINEA_TESTNET]: [lineaTestnetTokens.usdc]
};
var DEFAULT = {
  defaultConfig: {
    multicallChunk: 150,
    gasLimitOverride: 1e6
  },
  gasErrorFailureOverride: {
    gasLimitOverride: 1e6,
    multicallChunk: 30
  },
  successRateFailureOverrides: {
    gasLimitOverride: 1e6,
    multicallChunk: 40
  }
};
var BATCH_MULTICALL_CONFIGS = {
  // [ChainId.FIRECHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 50,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 45,
  //   },
  // },
  // [ChainId.RINIA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 50,
  //   },
  // },
  [ChainId.BSC_TESTNET]: DEFAULT,
  [ChainId.BSC]: {
    defaultConfig: {
      multicallChunk: 50,
      gasLimitOverride: 1e6
    },
    gasErrorFailureOverride: {
      gasLimitOverride: 1e6,
      multicallChunk: 40
    },
    successRateFailureOverrides: {
      gasLimitOverride: 1e6,
      multicallChunk: 45
    }
  },
  [ChainId.ETHEREUM]: DEFAULT,
  [ChainId.GOERLI]: DEFAULT,
  [ChainId.SEPOLIA]: DEFAULT,
  // [ChainId.POLYGON]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.POLYGON_MUMBAI]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CRO]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CRO_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.AVALANCHE]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.AVALANCHE_FUJI]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FANTOM_OPERA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FANTOM_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CELO]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CELO_ALFAJORES]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.OPTIMISM]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.OPTIMISM_GOERLI]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // // [ChainId.ARBITRUM]: {
  // //   defaultConfig: {
  // //     multicallChunk: 150,
  // //     gasLimitOverride: 1_000_000,
  // //   },
  // //   gasErrorFailureOverride: {
  // //     gasLimitOverride: 1_000_000,
  // //     multicallChunk: 30,
  // //   },
  // //   successRateFailureOverrides: {
  // //     gasLimitOverride: 1_000_000,
  // //     multicallChunk: 40,
  // //   },
  // // },
  // // [ChainId.ARBITRUM_GOERLI]: {
  // //   defaultConfig: {
  // //     multicallChunk: 150,
  // //     gasLimitOverride: 1_000_000,
  // //   },
  // //   gasErrorFailureOverride: {
  // //     gasLimitOverride: 1_000_000,
  // //     multicallChunk: 30,
  // //   },
  // //   successRateFailureOverrides: {
  // //     gasLimitOverride: 1_000_000,
  // //     multicallChunk: 40,
  // //   },
  // // },
  // [ChainId.SHIBARIUM]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.SHIBARIUM_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.PULSECHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.PULSECHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.XEN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.XEN_DEVNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.HARMONY]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.HARMONY_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.COINEX]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.COINEX_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.DOGECHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.DOGECHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ETHEREUM_CLASSIC]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ETHEREUM_CLASSIC_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FUSION]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FUSION_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.HECO]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.HECO_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.KCC]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.KCC_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.KLAYTN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.KLAYTN_BAOBAB]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.OKXCHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.OKXCHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.THETHA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.THETHA_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ULTRON]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ULTRON_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.MOONBEAM]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.MOONRIVER]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.MOONBASE_ALPHA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.AURORA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.AURORA_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.BOBA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.BOBA_GOERLI]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.GNOSIS]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.GNOSIS_CHIADO]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.METIS]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.METIS_GOERLI]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.TELOS]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.TELOS_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.SYSCOIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.SYSCOIN_TANENBAUM]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.IOTEX]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.IOTEX_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.SHIDEN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ASTAR]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.SHIBUNYA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FUSE]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FUSE_SPARKNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.VELAS]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.VELAS_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.REI]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.REI_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.KEKCHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.KEKCHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.TOMOCHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.TOMOCHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.THUNDERCORE]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.THUNDERCORE_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.WANCHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.WANCHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.RSK]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.RSK_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ELASTOS]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ELASTOS_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CONFLUX]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CONFLUX_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.BRISECHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.BRISECHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.MUUCHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.MUUCHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CANTO]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CANTO_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.OASIS_EMERALD]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.OASIS_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.VISION]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.VISION_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.STEP]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.STEP_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.METER]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.METER_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.GODWOKEN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.GODWOKEN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CALLISTO]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CALLISTO_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.EVMOS]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.EVMOS_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ENERGY_VOLTA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ENERGY_WEB_CHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.BASE]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.BASE_GOERLI]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.KAVA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.KAVA_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CLOVER]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.CLOVER_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.DEFICHAIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.DEFICHAIN_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.BRONOS]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.BRONOS_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FILECOIN]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FILECOIN_CALIBRATION]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FLARE]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.FLARE_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.TARAXA]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.TARAXA_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ZKSYNC]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  // [ChainId.ZKSYNC_TESTNET]: {
  //   defaultConfig: {
  //     multicallChunk: 150,
  //     gasLimitOverride: 1_000_000,
  //   },
  //   gasErrorFailureOverride: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 30,
  //   },
  //   successRateFailureOverrides: {
  //     gasLimitOverride: 1_000_000,
  //     multicallChunk: 40,
  //   },
  // },
  [ChainId.ARBITRUM_ONE]: {
    defaultConfig: {
      multicallChunk: 10,
      gasLimitOverride: 12e6
    },
    gasErrorFailureOverride: {
      gasLimitOverride: 3e7,
      multicallChunk: 6
    },
    successRateFailureOverrides: {
      gasLimitOverride: 3e7,
      multicallChunk: 6
    }
  },
  [ChainId.ARBITRUM_GOERLI]: DEFAULT,
  [ChainId.POLYGON_ZKEVM]: {
    defaultConfig: {
      multicallChunk: 3,
      gasLimitOverride: 3e5
    },
    gasErrorFailureOverride: {
      gasLimitOverride: 3e4,
      multicallChunk: 1
    },
    successRateFailureOverrides: {
      gasLimitOverride: 3e4,
      multicallChunk: 1
    }
  },
  [ChainId.POLYGON_ZKEVM_TESTNET]: {
    defaultConfig: {
      multicallChunk: 3,
      gasLimitOverride: 3e5
    },
    gasErrorFailureOverride: {
      gasLimitOverride: 3e4,
      multicallChunk: 1
    },
    successRateFailureOverrides: {
      gasLimitOverride: 3e4,
      multicallChunk: 1
    }
  },
  [ChainId.ZKSYNC]: DEFAULT,
  [ChainId.ZKSYNC_TESTNET]: DEFAULT,
  [ChainId.LINEA_TESTNET]: DEFAULT,
  [ChainId.FIRECHAIN]: DEFAULT,
  [ChainId.RINIA]: DEFAULT,
  [ChainId.POLYGON]: DEFAULT,
  [ChainId.POLYGON_MUMBAI]: DEFAULT,
  [ChainId.CRO]: DEFAULT,
  [ChainId.CRO_TESTNET]: DEFAULT,
  [ChainId.AVALANCHE]: DEFAULT,
  [ChainId.AVALANCHE_FUJI]: DEFAULT,
  [ChainId.FANTOM_OPERA]: DEFAULT,
  [ChainId.FANTOM_TESTNET]: DEFAULT,
  [ChainId.CELO]: DEFAULT,
  [ChainId.CELO_ALFAJORES]: DEFAULT,
  [ChainId.OPTIMISM]: DEFAULT,
  [ChainId.OPTIMISM_GOERLI]: DEFAULT,
  [ChainId.SHIBARIUM]: DEFAULT,
  [ChainId.SHIBARIUM_TESTNET]: DEFAULT,
  [ChainId.PULSECHAIN]: DEFAULT,
  [ChainId.PULSECHAIN_TESTNET]: DEFAULT,
  [ChainId.XEN]: DEFAULT,
  [ChainId.XEN_DEVNET]: DEFAULT,
  [ChainId.HARMONY]: DEFAULT,
  [ChainId.HARMONY_TESTNET]: DEFAULT,
  [ChainId.COINEX]: DEFAULT,
  [ChainId.COINEX_TESTNET]: DEFAULT,
  [ChainId.DOGECHAIN]: DEFAULT,
  [ChainId.DOGECHAIN_TESTNET]: DEFAULT,
  [ChainId.ETHEREUM_CLASSIC]: DEFAULT,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: DEFAULT,
  [ChainId.FUSION]: DEFAULT,
  [ChainId.FUSION_TESTNET]: DEFAULT,
  [ChainId.HECO]: DEFAULT,
  [ChainId.HECO_TESTNET]: DEFAULT,
  [ChainId.KCC]: DEFAULT,
  [ChainId.KCC_TESTNET]: DEFAULT,
  [ChainId.KLAYTN]: DEFAULT,
  [ChainId.KLAYTN_BAOBAB]: DEFAULT,
  [ChainId.OKXCHAIN]: DEFAULT,
  [ChainId.OKXCHAIN_TESTNET]: DEFAULT,
  [ChainId.THETHA]: DEFAULT,
  [ChainId.THETHA_TESTNET]: DEFAULT,
  [ChainId.ULTRON]: DEFAULT,
  [ChainId.ULTRON_TESTNET]: DEFAULT,
  [ChainId.MOONBEAM]: DEFAULT,
  [ChainId.MOONRIVER]: DEFAULT,
  [ChainId.MOONBASE_ALPHA]: DEFAULT,
  [ChainId.AURORA]: DEFAULT,
  [ChainId.AURORA_TESTNET]: DEFAULT,
  [ChainId.BOBA]: DEFAULT,
  [ChainId.BOBA_GOERLI]: DEFAULT,
  [ChainId.GNOSIS]: DEFAULT,
  [ChainId.GNOSIS_CHIADO]: DEFAULT,
  [ChainId.METIS]: DEFAULT,
  [ChainId.METIS_GOERLI]: DEFAULT,
  [ChainId.TELOS]: DEFAULT,
  [ChainId.TELOS_TESTNET]: DEFAULT,
  [ChainId.SYSCOIN]: DEFAULT,
  [ChainId.SYSCOIN_TANENBAUM]: DEFAULT,
  [ChainId.IOTEX]: DEFAULT,
  [ChainId.IOTEX_TESTNET]: DEFAULT,
  [ChainId.SHIDEN]: DEFAULT,
  [ChainId.ASTAR]: DEFAULT,
  [ChainId.SHIBUNYA]: DEFAULT,
  [ChainId.FUSE]: DEFAULT,
  [ChainId.FUSE_SPARKNET]: DEFAULT,
  [ChainId.VELAS]: DEFAULT,
  [ChainId.VELAS_TESTNET]: DEFAULT,
  [ChainId.REI]: DEFAULT,
  [ChainId.REI_TESTNET]: DEFAULT,
  [ChainId.KEKCHAIN]: DEFAULT,
  [ChainId.KEKCHAIN_TESTNET]: DEFAULT,
  [ChainId.TOMOCHAIN]: DEFAULT,
  [ChainId.TOMOCHAIN_TESTNET]: DEFAULT,
  [ChainId.THUNDERCORE]: DEFAULT,
  [ChainId.THUNDERCORE_TESTNET]: DEFAULT,
  [ChainId.WANCHAIN]: DEFAULT,
  [ChainId.WANCHAIN_TESTNET]: DEFAULT,
  [ChainId.RSK]: DEFAULT,
  [ChainId.RSK_TESTNET]: DEFAULT,
  [ChainId.ELASTOS]: DEFAULT,
  [ChainId.ELASTOS_TESTNET]: DEFAULT,
  [ChainId.CONFLUX]: DEFAULT,
  [ChainId.CONFLUX_TESTNET]: DEFAULT,
  [ChainId.BRISECHAIN]: DEFAULT,
  [ChainId.BRISECHAIN_TESTNET]: DEFAULT,
  [ChainId.MUUCHAIN]: DEFAULT,
  [ChainId.MUUCHAIN_TESTNET]: DEFAULT,
  [ChainId.CANTO]: DEFAULT,
  [ChainId.CANTO_TESTNET]: DEFAULT,
  [ChainId.OASIS_EMERALD]: DEFAULT,
  [ChainId.OASIS_TESTNET]: DEFAULT,
  [ChainId.VISION]: DEFAULT,
  [ChainId.VISION_TESTNET]: DEFAULT,
  [ChainId.STEP]: DEFAULT,
  [ChainId.STEP_TESTNET]: DEFAULT,
  [ChainId.METER]: DEFAULT,
  [ChainId.METER_TESTNET]: DEFAULT,
  [ChainId.GODWOKEN]: DEFAULT,
  [ChainId.GODWOKEN_TESTNET]: DEFAULT,
  [ChainId.CALLISTO]: DEFAULT,
  [ChainId.CALLISTO_TESTNET]: DEFAULT,
  [ChainId.EVMOS]: DEFAULT,
  [ChainId.EVMOS_TESTNET]: DEFAULT,
  [ChainId.ENERGY_WEB_CHAIN]: DEFAULT,
  [ChainId.ENERGY_VOLTA]: DEFAULT,
  [ChainId.BASE]: DEFAULT,
  [ChainId.BASE_GOERLI]: DEFAULT,
  [ChainId.KAVA]: DEFAULT,
  [ChainId.KAVA_TESTNET]: DEFAULT,
  [ChainId.CLOVER]: DEFAULT,
  [ChainId.CLOVER_TESTNET]: DEFAULT,
  [ChainId.DEFICHAIN]: DEFAULT,
  [ChainId.DEFICHAIN_TESTNET]: DEFAULT,
  [ChainId.BRONOS]: DEFAULT,
  [ChainId.BRONOS_TESTNET]: DEFAULT,
  [ChainId.FILECOIN]: DEFAULT,
  [ChainId.FILECOIN_CALIBRATION]: DEFAULT,
  [ChainId.FLARE]: DEFAULT,
  [ChainId.FLARE_TESTNET]: DEFAULT,
  [ChainId.TARAXA]: DEFAULT,
  [ChainId.TARAXA_TESTNET]: DEFAULT
};

// evm/constants/stableSwap/529.ts
var pools = [];

// evm/constants/stableSwap/917.ts
var pools2 = [];

// evm/constants/stableSwap/1.ts
var pools3 = [];

// evm/constants/stableSwap/5.ts
var pools4 = [];

// evm/constants/stableSwap/11155111.ts
var pools5 = [];
var pools6 = [
  {
    lpSymbol: "HAY-BUSD LP",
    lpAddress: "0xB6040A9F294477dDAdf5543a24E5463B8F2423Ae",
    token: bscTokens.hay,
    quoteToken: bscTokens.busd,
    stableSwapAddress: "0x49079d07ef47449af808a4f36c2a8dec975594ec",
    infoStableSwapAddress: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDT-BUSD LP",
    lpAddress: "0x36842F8fb99D55477C0Da638aF5ceb6bBf86aA98",
    token: bscTokens.usdt,
    quoteToken: bscTokens.busd,
    stableSwapAddress: "0x169F653A54ACD441aB34B73dA9946e2C451787EF",
    infoStableSwapAddress: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
    stableLpFee: 5e-5,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDC-BUSD LP",
    lpAddress: "0x1A77C359D0019cD8F4d36b7CDf5a88043D801072",
    token: bscTokens.usdc,
    quoteToken: bscTokens.busd,
    stableSwapAddress: "0xc2F5B9a3d9138ab2B74d581fC11346219eBf43Fe",
    infoStableSwapAddress: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
    stableLpFee: 5e-5,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDT-USDC LP",
    lpAddress: "0xee1bcc9F1692E81A281b3a302a4b67890BA4be76",
    token: bscTokens.usdt,
    quoteToken: bscTokens.usdc,
    stableSwapAddress: "0x3EFebC418efB585248A0D2140cfb87aFcc2C63DD",
    infoStableSwapAddress: "0xa680d27f63Fa5E213C502d1B3Ca1EB6a3C1b31D6",
    stableLpFee: 5e-5,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "axlUSDC-USDT LP",
    lpAddress: "0x1c7e5a3A72b6D94DE5Ec20812E3e68713978a584",
    token: bscTokens.axlusdc,
    quoteToken: bscTokens.usdt,
    stableSwapAddress: "0x6D8fba276ec6F1EDa2344DA48565AdbCA7e4FFa5",
    infoStableSwapAddress: "0x150c8AbEB487137acCC541925408e73b92F39A50",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "WBNB-stkBNB LP",
    lpAddress: "0x9976f5c8BEfDee650226d5571d5F5551e8722b75",
    token: bscTokens.wbnb,
    quoteToken: bscTokens.stkbnb,
    stableSwapAddress: "0x0b03e3d6Ec0c5e5bBf993dED8D947C6fb6eEc18D",
    infoStableSwapAddress: "0x150c8AbEB487137acCC541925408e73b92F39A50",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "BNBx-BNB LP",
    lpAddress: "0x92357Ab9003CA881E08e32CDAE59B10B3161b05C",
    token: bscTokens.bnbx,
    quoteToken: bscTokens.wbnb,
    stableSwapAddress: "0x9c138bE1D76ee4C5162E0fe9D4eEA5542a23D1bD",
    infoStableSwapAddress: "0x150c8AbEB487137acCC541925408e73b92F39A50",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "HAY-USDT LP",
    lpAddress: "0xB2Aa63f363196caba3154D4187949283F085a488",
    token: bscTokens.hay,
    quoteToken: bscTokens.usdt,
    stableSwapAddress: "0xb1Da7D2C257c5700612BdE35C8d7187dc80d79f1",
    infoStableSwapAddress: "0x150c8AbEB487137acCC541925408e73b92F39A50",
    stableLpFee: 4e-4,
    stableLpFeeRateOfTotalFee: 0.5
  }
];
var mockUSDT = new ERC20Token(
  ChainId.BSC_TESTNET,
  "0x0fB5D7c73FA349A90392f873a4FA1eCf6a3d0a96",
  18,
  "USDT",
  "MOCK Token"
);
var pools7 = [
  // {
  //   lpSymbol: 'USDC-BUSD LP',
  //   lpAddress: '0xd1742b5eC6798cEB8C791e0ebbEf606A4946f67E',
  //   token: bscTestnetTokens.usdc, // coins[0]
  //   quoteToken: bscTestnetTokens.busd, // coins[1]
  //   stableSwapAddress: '0x1288026D2c5a76A5bfb0730F615131A448f4Ad06',
  //   infoStableSwapAddress: '0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546',
  // },
  {
    lpSymbol: "USDT-WBNB LP",
    lpAddress: "0x4c091Dc4418Bd3353A87488535528FD86954da2c",
    token: mockUSDT,
    // coins[0]
    quoteToken: bscTestnetTokens.wbnb,
    // coins[1]
    stableSwapAddress: "0xBcd585Ee8B8Ac8de6b0e45dA32Aa31703036b2a1",
    infoStableSwapAddress: "0x0A548d59D04096Bc01206D58C3D63c478e1e06dB",
    stableLpFee: 4e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDT-BUSD LP",
    lpAddress: "0x746a7063101E2D3305D1556888ee08193f2B9a07",
    token: mockUSDT,
    // coins[0]
    quoteToken: bscTestnetTokens.busd,
    // coins[1]
    stableSwapAddress: "0xE25A1352477f3DB9B3008B31e9b7a07a18f8A9e6",
    infoStableSwapAddress: "0x0A548d59D04096Bc01206D58C3D63c478e1e06dB",
    stableLpFee: 4e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "BUSD-USDC LP",
    lpAddress: "0x7CA885d338462790DD1B5416ebe6bec75ee045a1",
    token: bscTestnetTokens.mockBusd,
    // coins[0]
    quoteToken: bscTestnetTokens.usdc,
    // coins[1]
    stableSwapAddress: "0xd5E56CD4c8111643a94Ee084df31F44055a1EC9F",
    infoStableSwapAddress: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  },
  {
    lpSymbol: "USDT-BUSD LP",
    lpAddress: "0x9Fa2Ef2C3dF6F903F4b73047311e861C51a11B60",
    token: bscTestnetTokens.usdt,
    // coins[0]
    quoteToken: bscTestnetTokens.mockBusd,
    // coins[1]
    stableSwapAddress: "0xc418d68751Cbe0407C8fdd90Cde73cE95b892f39",
    infoStableSwapAddress: "0xaE6C14AAA753B3FCaB96149e1E10Bc4EDF39F546",
    stableLpFee: 2e-4,
    stableLpFeeRateOfTotalFee: 0.5
  }
];

// evm/constants/stableSwap/137.ts
var pools8 = [];

// evm/constants/stableSwap/80001.ts
var pools9 = [];

// evm/constants/stableSwap/1101.ts
var pools10 = [];

// evm/constants/stableSwap/1442.ts
var pools11 = [];

// evm/constants/stableSwap/25.ts
var pools12 = [];

// evm/constants/stableSwap/338.ts
var pools13 = [];

// evm/constants/stableSwap/43114.ts
var pools14 = [];

// evm/constants/stableSwap/43113.ts
var pools15 = [];

// evm/constants/stableSwap/250.ts
var pools16 = [];

// evm/constants/stableSwap/4002.ts
var pools17 = [];

// evm/constants/stableSwap/42220.ts
var pools18 = [];

// evm/constants/stableSwap/44787.ts
var pools19 = [];

// evm/constants/stableSwap/10.ts
var pools20 = [];

// evm/constants/stableSwap/420.ts
var pools21 = [];

// evm/constants/stableSwap/42161.ts
var pools22 = [];

// evm/constants/stableSwap/421613.ts
var pools23 = [];

// evm/constants/stableSwap/9991.ts
var pools24 = [];

// evm/constants/stableSwap/719.ts
var pools25 = [];

// evm/constants/stableSwap/369.ts
var pools26 = [];

// evm/constants/stableSwap/941.ts
var pools27 = [];

// evm/constants/stableSwap/20221200000.ts
var pools28 = [];

// evm/constants/stableSwap/202212.ts
var pools29 = [];

// evm/constants/stableSwap/1666600000.ts
var pools30 = [];

// evm/constants/stableSwap/1666700000.ts
var pools31 = [];

// evm/constants/stableSwap/52.ts
var pools32 = [];

// evm/constants/stableSwap/53.ts
var pools33 = [];

// evm/constants/stableSwap/2000.ts
var pools34 = [];

// evm/constants/stableSwap/568.ts
var pools35 = [];

// evm/constants/stableSwap/61.ts
var pools36 = [];

// evm/constants/stableSwap/63.ts
var pools37 = [];

// evm/constants/stableSwap/32659.ts
var pools38 = [];

// evm/constants/stableSwap/46688.ts
var pools39 = [];

// evm/constants/stableSwap/128.ts
var pools40 = [];

// evm/constants/stableSwap/256.ts
var pools41 = [];

// evm/constants/stableSwap/321.ts
var pools42 = [];

// evm/constants/stableSwap/322.ts
var pools43 = [];

// evm/constants/stableSwap/8217.ts
var pools44 = [];

// evm/constants/stableSwap/1001.ts
var pools45 = [];

// evm/constants/stableSwap/66.ts
var pools46 = [];

// evm/constants/stableSwap/65.ts
var pools47 = [];

// evm/constants/stableSwap/361.ts
var pools48 = [];

// evm/constants/stableSwap/365.ts
var pools49 = [];

// evm/constants/stableSwap/1231.ts
var pools50 = [];

// evm/constants/stableSwap/1230.ts
var pools51 = [];

// evm/constants/stableSwap/1284.ts
var pools52 = [];

// evm/constants/stableSwap/1285.ts
var pools53 = [];

// evm/constants/stableSwap/1287.ts
var pools54 = [];

// evm/constants/stableSwap/1313161554.ts
var pools55 = [];

// evm/constants/stableSwap/1313161555.ts
var pools56 = [];

// evm/constants/stableSwap/288.ts
var pools57 = [];

// evm/constants/stableSwap/2888.ts
var pools58 = [];

// evm/constants/stableSwap/100.ts
var pools59 = [];

// evm/constants/stableSwap/10200.ts
var pools60 = [];

// evm/constants/stableSwap/1088.ts
var pools61 = [];

// evm/constants/stableSwap/599.ts
var pools62 = [];

// evm/constants/stableSwap/40.ts
var pools63 = [];

// evm/constants/stableSwap/41.ts
var pools64 = [];

// evm/constants/stableSwap/57.ts
var pools65 = [];

// evm/constants/stableSwap/5700.ts
var pools66 = [];

// evm/constants/stableSwap/4689.ts
var pools67 = [];

// evm/constants/stableSwap/4690.ts
var pools68 = [];

// evm/constants/stableSwap/336.ts
var pools69 = [];

// evm/constants/stableSwap/592.ts
var pools70 = [];

// evm/constants/stableSwap/81.ts
var pools71 = [];

// evm/constants/stableSwap/122.ts
var pools72 = [];

// evm/constants/stableSwap/123.ts
var pools73 = [];

// evm/constants/stableSwap/106.ts
var pools74 = [];

// evm/constants/stableSwap/111.ts
var pools75 = [];

// evm/constants/stableSwap/55555.ts
var pools76 = [];

// evm/constants/stableSwap/55556.ts
var pools77 = [];

// evm/constants/stableSwap/420420.ts
var pools78 = [];

// evm/constants/stableSwap/420666.ts
var pools79 = [];

// evm/constants/stableSwap/88.ts
var pools80 = [];

// evm/constants/stableSwap/89.ts
var pools81 = [];

// evm/constants/stableSwap/108.ts
var pools82 = [];

// evm/constants/stableSwap/18.ts
var pools83 = [];

// evm/constants/stableSwap/888.ts
var pools84 = [];

// evm/constants/stableSwap/999.ts
var pools85 = [];

// evm/constants/stableSwap/30.ts
var pools86 = [];

// evm/constants/stableSwap/31.ts
var pools87 = [];

// evm/constants/stableSwap/20.ts
var pools88 = [];

// evm/constants/stableSwap/21.ts
var pools89 = [];

// evm/constants/stableSwap/1030.ts
var pools90 = [];

// evm/constants/stableSwap/71.ts
var pools91 = [];

// evm/constants/stableSwap/32520.ts
var pools92 = [];

// evm/constants/stableSwap/64668.ts
var pools93 = [];

// evm/constants/stableSwap/20402.ts
var pools94 = [];

// evm/constants/stableSwap/42110.ts
var pools95 = [];

// evm/constants/stableSwap/7700.ts
var pools96 = [];

// evm/constants/stableSwap/740.ts
var pools97 = [];

// evm/constants/stableSwap/42262.ts
var pools98 = [];

// evm/constants/stableSwap/42261.ts
var pools99 = [];

// evm/constants/stableSwap/888888.ts
var pools100 = [];

// evm/constants/stableSwap/666666.ts
var pools101 = [];

// evm/constants/stableSwap/1234.ts
var pools102 = [];

// evm/constants/stableSwap/12345.ts
var pools103 = [];

// evm/constants/stableSwap/82.ts
var pools104 = [];

// evm/constants/stableSwap/83.ts
var pools105 = [];

// evm/constants/stableSwap/71402.ts
var pools106 = [];

// evm/constants/stableSwap/71401.ts
var pools107 = [];

// evm/constants/stableSwap/820.ts
var pools108 = [];

// evm/constants/stableSwap/20729.ts
var pools109 = [];

// evm/constants/stableSwap/9001.ts
var pools110 = [];

// evm/constants/stableSwap/9000.ts
var pools111 = [];

// evm/constants/stableSwap/246.ts
var pools112 = [];

// evm/constants/stableSwap/73799.ts
var pools113 = [];

// evm/constants/stableSwap/9993.ts
var pools114 = [];

// evm/constants/stableSwap/84531.ts
var pools115 = [];

// evm/constants/stableSwap/2222.ts
var pools116 = [];

// evm/constants/stableSwap/2221.ts
var pools117 = [];

// evm/constants/stableSwap/1024.ts
var pools118 = [];

// evm/constants/stableSwap/1023.ts
var pools119 = [];

// evm/constants/stableSwap/1131.ts
var pools120 = [];

// evm/constants/stableSwap/1132.ts
var pools121 = [];

// evm/constants/stableSwap/1039.ts
var pools122 = [];

// evm/constants/stableSwap/1038.ts
var pools123 = [];

// evm/constants/stableSwap/314.ts
var pools124 = [];

// evm/constants/stableSwap/314159.ts
var pools125 = [];

// evm/constants/stableSwap/14.ts
var pools126 = [];

// evm/constants/stableSwap/114.ts
var pools127 = [];

// evm/constants/stableSwap/841.ts
var pools128 = [];

// evm/constants/stableSwap/842.ts
var pools129 = [];

// evm/constants/stableSwap/324.ts
var pools130 = [];

// evm/constants/stableSwap/280.ts
var pools131 = [];

// evm/constants/stableSwap/59140.ts
var pools132 = [];

// evm/constants/stableSwap/pools.ts
var isStableSwapSupported = (chainId) => STABLE_SUPPORTED_CHAIN_IDS.includes(chainId);
var STABLE_SUPPORTED_CHAIN_IDS = [
  ChainId.FIRECHAIN,
  ChainId.RINIA,
  ChainId.ETHEREUM,
  ChainId.GOERLI,
  ChainId.SEPOLIA,
  ChainId.BSC,
  ChainId.BSC_TESTNET,
  ChainId.POLYGON,
  ChainId.POLYGON_MUMBAI,
  ChainId.POLYGON_ZKEVM,
  ChainId.POLYGON_ZKEVM_TESTNET,
  ChainId.CRO,
  ChainId.CRO_TESTNET,
  ChainId.AVALANCHE,
  ChainId.AVALANCHE_FUJI,
  ChainId.FANTOM_OPERA,
  ChainId.FANTOM_TESTNET,
  ChainId.CELO,
  ChainId.CELO_ALFAJORES,
  ChainId.OPTIMISM,
  ChainId.OPTIMISM_GOERLI,
  ChainId.ARBITRUM_ONE,
  ChainId.ARBITRUM_GOERLI,
  ChainId.SHIBARIUM,
  ChainId.SHIBARIUM_TESTNET,
  ChainId.PULSECHAIN,
  ChainId.PULSECHAIN_TESTNET,
  ChainId.XEN,
  ChainId.XEN_DEVNET,
  ChainId.HARMONY,
  ChainId.HARMONY_TESTNET,
  ChainId.COINEX,
  ChainId.COINEX_TESTNET,
  ChainId.DOGECHAIN,
  ChainId.DOGECHAIN_TESTNET,
  ChainId.ETHEREUM_CLASSIC,
  ChainId.ETHEREUM_CLASSIC_TESTNET,
  ChainId.FUSION,
  ChainId.FUSION_TESTNET,
  ChainId.HECO,
  ChainId.HECO_TESTNET,
  ChainId.KCC,
  ChainId.KCC_TESTNET,
  ChainId.KLAYTN,
  ChainId.KLAYTN_BAOBAB,
  ChainId.OKXCHAIN,
  ChainId.OKXCHAIN_TESTNET,
  ChainId.THETHA,
  ChainId.THETHA_TESTNET,
  ChainId.ULTRON,
  ChainId.ULTRON_TESTNET,
  ChainId.MOONBEAM,
  ChainId.MOONRIVER,
  ChainId.MOONBASE_ALPHA,
  ChainId.AURORA,
  ChainId.AURORA_TESTNET,
  ChainId.BOBA,
  ChainId.BOBA_GOERLI,
  ChainId.GNOSIS,
  ChainId.GNOSIS_CHIADO,
  ChainId.METIS,
  ChainId.METIS_GOERLI,
  ChainId.TELOS,
  ChainId.TELOS_TESTNET,
  ChainId.SYSCOIN,
  ChainId.SYSCOIN_TANENBAUM,
  ChainId.IOTEX,
  ChainId.IOTEX_TESTNET,
  ChainId.SHIDEN,
  ChainId.ASTAR,
  ChainId.SHIBUNYA,
  ChainId.FUSE,
  ChainId.FUSE_SPARKNET,
  ChainId.VELAS,
  ChainId.VELAS_TESTNET,
  ChainId.REI,
  ChainId.REI_TESTNET,
  ChainId.KEKCHAIN,
  ChainId.KEKCHAIN_TESTNET,
  ChainId.TOMOCHAIN,
  ChainId.TOMOCHAIN_TESTNET,
  ChainId.THUNDERCORE,
  ChainId.THUNDERCORE_TESTNET,
  ChainId.WANCHAIN,
  ChainId.WANCHAIN_TESTNET,
  ChainId.RSK,
  ChainId.RSK_TESTNET,
  ChainId.ELASTOS,
  ChainId.ELASTOS_TESTNET,
  ChainId.CONFLUX,
  ChainId.CONFLUX_TESTNET,
  ChainId.BRISECHAIN,
  ChainId.BRISECHAIN_TESTNET,
  ChainId.MUUCHAIN,
  ChainId.MUUCHAIN_TESTNET,
  ChainId.CANTO,
  ChainId.CANTO_TESTNET,
  ChainId.OASIS_EMERALD,
  ChainId.OASIS_TESTNET,
  ChainId.VISION,
  ChainId.VISION_TESTNET,
  ChainId.STEP,
  ChainId.STEP_TESTNET,
  ChainId.METER,
  ChainId.METER_TESTNET,
  ChainId.GODWOKEN,
  ChainId.GODWOKEN_TESTNET,
  ChainId.CALLISTO,
  ChainId.CALLISTO_TESTNET,
  ChainId.EVMOS,
  ChainId.EVMOS_TESTNET,
  ChainId.ENERGY_WEB_CHAIN,
  ChainId.ENERGY_VOLTA,
  ChainId.BASE,
  ChainId.BASE_GOERLI,
  ChainId.KAVA,
  ChainId.KAVA_TESTNET,
  ChainId.CLOVER,
  ChainId.CLOVER_TESTNET,
  ChainId.DEFICHAIN,
  ChainId.DEFICHAIN_TESTNET,
  ChainId.BRONOS,
  ChainId.BRONOS_TESTNET,
  ChainId.FILECOIN,
  ChainId.FILECOIN_CALIBRATION,
  ChainId.FLARE,
  ChainId.FLARE_TESTNET,
  ChainId.TARAXA,
  ChainId.TARAXA_TESTNET,
  ChainId.ZKSYNC,
  ChainId.ZKSYNC_TESTNET,
  ChainId.LINEA_TESTNET
];
var STABLE_POOL_MAP = {
  [ChainId.FIRECHAIN]: pools,
  [ChainId.RINIA]: pools2,
  [ChainId.ETHEREUM]: pools3,
  [ChainId.GOERLI]: pools4,
  [ChainId.SEPOLIA]: pools5,
  [ChainId.BSC]: pools6,
  [ChainId.BSC_TESTNET]: pools7,
  [ChainId.POLYGON]: pools8,
  [ChainId.POLYGON_MUMBAI]: pools9,
  [ChainId.POLYGON_ZKEVM]: pools10,
  [ChainId.POLYGON_ZKEVM_TESTNET]: pools11,
  [ChainId.CRO]: pools12,
  [ChainId.CRO_TESTNET]: pools13,
  [ChainId.AVALANCHE]: pools14,
  [ChainId.AVALANCHE_FUJI]: pools15,
  [ChainId.FANTOM_OPERA]: pools16,
  [ChainId.FANTOM_TESTNET]: pools17,
  [ChainId.CELO]: pools18,
  [ChainId.CELO_ALFAJORES]: pools19,
  [ChainId.OPTIMISM]: pools20,
  [ChainId.OPTIMISM_GOERLI]: pools21,
  [ChainId.ARBITRUM_ONE]: pools22,
  [ChainId.ARBITRUM_GOERLI]: pools23,
  [ChainId.SHIBARIUM]: pools24,
  [ChainId.SHIBARIUM_TESTNET]: pools25,
  [ChainId.PULSECHAIN]: pools26,
  [ChainId.PULSECHAIN_TESTNET]: pools27,
  [ChainId.XEN]: pools28,
  [ChainId.XEN_DEVNET]: pools29,
  [ChainId.HARMONY]: pools30,
  [ChainId.HARMONY_TESTNET]: pools31,
  [ChainId.COINEX]: pools32,
  [ChainId.COINEX_TESTNET]: pools33,
  [ChainId.DOGECHAIN]: pools34,
  [ChainId.DOGECHAIN_TESTNET]: pools35,
  [ChainId.ETHEREUM_CLASSIC]: pools36,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: pools37,
  [ChainId.FUSION]: pools38,
  [ChainId.FUSION_TESTNET]: pools39,
  [ChainId.HECO]: pools40,
  [ChainId.HECO_TESTNET]: pools41,
  [ChainId.KCC]: pools42,
  [ChainId.KCC_TESTNET]: pools43,
  [ChainId.KLAYTN]: pools44,
  [ChainId.KLAYTN_BAOBAB]: pools45,
  [ChainId.OKXCHAIN]: pools46,
  [ChainId.OKXCHAIN_TESTNET]: pools47,
  [ChainId.THETHA]: pools48,
  [ChainId.THETHA_TESTNET]: pools49,
  [ChainId.ULTRON]: pools50,
  [ChainId.ULTRON_TESTNET]: pools51,
  [ChainId.MOONBEAM]: pools52,
  [ChainId.MOONRIVER]: pools53,
  [ChainId.MOONBASE_ALPHA]: pools54,
  [ChainId.AURORA]: pools55,
  [ChainId.AURORA_TESTNET]: pools56,
  [ChainId.BOBA]: pools57,
  [ChainId.BOBA_GOERLI]: pools58,
  [ChainId.GNOSIS]: pools59,
  [ChainId.GNOSIS_CHIADO]: pools60,
  [ChainId.METIS]: pools61,
  [ChainId.METIS_GOERLI]: pools62,
  [ChainId.TELOS]: pools63,
  [ChainId.TELOS_TESTNET]: pools64,
  [ChainId.SYSCOIN]: pools65,
  [ChainId.SYSCOIN_TANENBAUM]: pools66,
  [ChainId.IOTEX]: pools67,
  [ChainId.IOTEX_TESTNET]: pools68,
  [ChainId.SHIDEN]: pools69,
  [ChainId.ASTAR]: pools70,
  [ChainId.SHIBUNYA]: pools71,
  [ChainId.FUSE]: pools72,
  [ChainId.FUSE_SPARKNET]: pools73,
  [ChainId.VELAS]: pools74,
  [ChainId.VELAS_TESTNET]: pools75,
  [ChainId.REI]: pools76,
  [ChainId.REI_TESTNET]: pools77,
  [ChainId.KEKCHAIN]: pools78,
  [ChainId.KEKCHAIN_TESTNET]: pools79,
  [ChainId.TOMOCHAIN]: pools80,
  [ChainId.TOMOCHAIN_TESTNET]: pools81,
  [ChainId.THUNDERCORE]: pools82,
  [ChainId.THUNDERCORE_TESTNET]: pools83,
  [ChainId.WANCHAIN]: pools84,
  [ChainId.WANCHAIN_TESTNET]: pools85,
  [ChainId.RSK]: pools86,
  [ChainId.RSK_TESTNET]: pools87,
  [ChainId.ELASTOS]: pools88,
  [ChainId.ELASTOS_TESTNET]: pools89,
  [ChainId.CONFLUX]: pools90,
  [ChainId.CONFLUX_TESTNET]: pools91,
  [ChainId.BRISECHAIN]: pools92,
  [ChainId.BRISECHAIN_TESTNET]: pools93,
  [ChainId.MUUCHAIN]: pools94,
  [ChainId.MUUCHAIN_TESTNET]: pools95,
  [ChainId.CANTO]: pools96,
  [ChainId.CANTO_TESTNET]: pools97,
  [ChainId.OASIS_EMERALD]: pools98,
  [ChainId.OASIS_TESTNET]: pools99,
  [ChainId.VISION]: pools100,
  [ChainId.VISION_TESTNET]: pools101,
  [ChainId.STEP]: pools102,
  [ChainId.STEP_TESTNET]: pools103,
  [ChainId.METER]: pools104,
  [ChainId.METER_TESTNET]: pools105,
  [ChainId.GODWOKEN]: pools106,
  [ChainId.GODWOKEN_TESTNET]: pools107,
  [ChainId.CALLISTO]: pools108,
  [ChainId.CALLISTO_TESTNET]: pools109,
  [ChainId.EVMOS]: pools110,
  [ChainId.EVMOS_TESTNET]: pools111,
  [ChainId.ENERGY_WEB_CHAIN]: pools112,
  [ChainId.ENERGY_VOLTA]: pools113,
  [ChainId.BASE]: pools114,
  [ChainId.BASE_GOERLI]: pools115,
  [ChainId.KAVA]: pools116,
  [ChainId.KAVA_TESTNET]: pools117,
  [ChainId.CLOVER]: pools118,
  [ChainId.CLOVER_TESTNET]: pools119,
  [ChainId.DEFICHAIN]: pools120,
  [ChainId.DEFICHAIN_TESTNET]: pools121,
  [ChainId.BRONOS]: pools122,
  [ChainId.BRONOS_TESTNET]: pools123,
  [ChainId.FILECOIN]: pools124,
  [ChainId.FILECOIN_CALIBRATION]: pools125,
  [ChainId.FLARE]: pools126,
  [ChainId.FLARE_TESTNET]: pools127,
  [ChainId.TARAXA]: pools128,
  [ChainId.TARAXA_TESTNET]: pools129,
  [ChainId.ZKSYNC]: pools130,
  [ChainId.ZKSYNC_TESTNET]: pools131,
  [ChainId.LINEA_TESTNET]: pools132
};

// evm/constants/stableSwap/index.ts
function getStableSwapPools(chainId) {
  if (!isStableSwapSupported(chainId)) {
    return [];
  }
  return STABLE_POOL_MAP[chainId] || [];
}
function wrappedCurrency(currency, chainId) {
  return currency?.isNative ? WNATIVE[chainId] : currency?.isToken ? currency : void 0;
}
function wrappedCurrencyAmount(currencyAmount, chainId) {
  const token = currencyAmount && chainId ? wrappedCurrency(currencyAmount.currency, chainId) : void 0;
  return token && currencyAmount ? CurrencyAmount.fromRawAmount(token, currencyAmount.quotient) : void 0;
}

// evm/abis/IPancakePair.ts
var pancakePairABI = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      }
    ],
    name: "Sync",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MINIMUM_LIQUIDITY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getReserves",
    outputs: [
      {
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      },
      {
        internalType: "uint32",
        name: "blockTimestampLast",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "kLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "price0CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "price1CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "skim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "sync",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token0",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token1",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// evm/abis/StableSwapPair.ts
var stableSwapPairABI = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "invariant",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "AddLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "admin_fee",
        type: "uint256"
      }
    ],
    name: "CommitNewFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "DonateAdminFees",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "Kill",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "admin_fee",
        type: "uint256"
      }
    ],
    name: "NewFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "old_A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "new_A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "initial_time",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "future_time",
        type: "uint256"
      }
    ],
    name: "RampA",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidity",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "token_amounts",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "fees",
        type: "uint256[2]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "invariant",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_supply",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidityImbalance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "provider",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token_amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "coin_amount",
        type: "uint256"
      }
    ],
    name: "RemoveLiquidityOne",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "RevertParameters",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "A",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "t",
        type: "uint256"
      }
    ],
    name: "StopRampA",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sold_id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokens_sold",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bought_id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokens_bought",
        type: "uint256"
      }
    ],
    name: "TokenExchange",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "Unkill",
    type: "event"
  },
  {
    inputs: [],
    name: "A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ADMIN_ACTIONS_DELAY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "FEE_DENOMINATOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "KILL_DEADLINE_DT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_ADMIN_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_A_CHANGE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_DECIMAL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MIN_RAMP_TIME",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "N_COINS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "PRECISION_MUL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "RATES",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "STABLESWAP_FACTORY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "uint256",
        name: "min_mint_amount",
        type: "uint256"
      }
    ],
    name: "add_liquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "admin_actions_deadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      }
    ],
    name: "admin_balances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "admin_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "apply_new_fee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "bool",
        name: "deposit",
        type: "bool"
      }
    ],
    name: "calc_token_amount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_token_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      }
    ],
    name: "calc_withdraw_one_coin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "coins",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "new_fee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "new_admin_fee",
        type: "uint256"
      }
    ],
    name: "commit_new_fee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "donate_admin_fees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "min_dy",
        type: "uint256"
      }
    ],
    name: "exchange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_A_time",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_admin_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "future_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      }
    ],
    name: "get_dy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "j",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256"
      }
    ],
    name: "get_dy_underlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "get_virtual_price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initial_A",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initial_A_time",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[2]",
        name: "_coins",
        type: "address[2]"
      },
      {
        internalType: "uint256",
        name: "_A",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_admin_fee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "is_killed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "kill_deadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "kill_me",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_future_A",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_future_time",
        type: "uint256"
      }
    ],
    name: "ramp_A",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256[2]",
        name: "min_amounts",
        type: "uint256[2]"
      }
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "amounts",
        type: "uint256[2]"
      },
      {
        internalType: "uint256",
        name: "max_burn_amount",
        type: "uint256"
      }
    ],
    name: "remove_liquidity_imbalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_token_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "i",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "min_amount",
        type: "uint256"
      }
    ],
    name: "remove_liquidity_one_coin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "revert_new_parameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "stop_rampget_A",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract PancakeStableSwapLP",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unkill_me",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdraw_admin_fees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

export { ADDITIONAL_BASES, ADDRESS_THIS, BASES_TO_CHECK_TRADES_AGAINST, BASE_SWAP_COST_STABLE_SWAP, BASE_SWAP_COST_V2, BASE_SWAP_COST_V3, BATCH_MULTICALL_CONFIGS, BETTER_TRADE_LESS_HOPS_THRESHOLD, BIG_INT_TEN, BIPS_BASE, CHAIN_ID_TO_CHAIN_NAME, COST_PER_EXTRA_HOP_STABLE_SWAP, COST_PER_EXTRA_HOP_V2, COST_PER_HOP_V3, COST_PER_INIT_TICK, COST_PER_UNINIT_TICK, CUSTOM_BASES, MIN_BNB, MIXED_ROUTE_QUOTER_ADDRESSES, MSG_SENDER, SMART_ROUTER_ADDRESSES, STABLE_SUPPORTED_CHAIN_IDS, STABLE_SWAP_INFO_ADDRESS, V2_FEE_PATH_PLACEHOLDER, V2_ROUTER_ADDRESS, V3_QUOTER_ADDRESSES, __export, getStableSwapPools, isStableSwapSupported, pancakePairABI, stableSwapPairABI, usdGasTokensByChain, wrappedCurrency, wrappedCurrencyAmount };
